/* Edit History is below */
import Vue from 'vue';
import Es6Promise from 'es6-promise';
import Vuex from 'vuex';
// import { openDB } from 'idb';
import getTR from '../trnum';
// eslint-disable-next-line
import utl from '../myUtils';

const sprintf = require('sprintf-js').sprintf;

Es6Promise.polyfill();
Vue.use(Vuex);
// const ws = new Vue();
// const ws = new WebSocket('wss://betaserv.pt4web.com/wss');

const $spk = require('schemapack');

/* Edit History - Change in cliVer (below)
  04/01/2018 - 02/18/2019 [001] - [063] Writing code
  02/19/2019 [064] Fix issue with Token not populating after removing diag code
  02/20/2019 [065] Get Transfer working from Menu
  02/20/2019 [066] Grey out disabled buttons
  02/28/2019 [067] Fix History for share type 'P' (was doing 'D')
  02/28/2019 [068] Blank out history when initializing a search
  05/01/2019 [069] Fix xfer dollar amount ($68.24 was becoming $99,999,999.99) *100 rounding error
  05/01/2019 [070] Negatives not valid for xfer amount (disable 'Transfer' button)
  05/04/2019 [071] Get preliminary history print (temporary)
  09/04/2019 [072] Preliminary save acct/pass
  09/13/2019 [073] Fix issue with saved accounts not showing up
  09/13/2019 [074] Re-read saved accounts at SignOff if we saved a new one
  09/21/2019 [075] Partial Implementation of Statements (displays list)
  09/22/2019 [076] Preliminary test of external browser Statements
  09/22/2019 [077] Preliminary test of internal browser Statements
  09/23/2019 [078] Statements complete and working with Internal Browser
  09/24/2019 [079] Preliminary CU Selection screen (non-functional)
  09/27/2019 [080] Auto Cu Selection works - Add works (delete and select does not)
  09/27/2019 [081] Add [Back] button to top left of Statement (Julie at Indiana Lakes request)
  09/28/2019 [082] Get Activate / Add / Delete CU working
  09/30/2019 [083] Move items on menu and change label to "Reserved" for unimplemented buttons
  10/08/2019 [084] Implement Change Password
  10/18/2019 [085] Left-Justify account check boxes on Transfer Screen
  11/07/2019 [086] Finished up "Change Password"
  11/07/2019 [087] Finished up "Unlock Account"
  11/08/2019 [086] Deploy Password Change / Password Recovery working
  11/08/2019 [087] Deploy Unlock Account working
  12/14/2019 [088] Get "Hide Password" working on MS Edge (Sign-On)
  12/21/2019 [089] Get "Hide Password" working on MS Edge (Sign-On)
  12/28/2019 [090] Keep CU# on URL line when signed-out (instead of "Sign-In")
  02/09/2020 [091] Get ONE-TIME working - Also fixes if cookies not saved
  02/23/2020 [092] Switch from VueNativeSock to new WebSocket(url)
                   Allows conditional open (URL based on IP)
  04/05/2020 [093] Add Enroll Page
  04/12/2020 [094] Get Auto checks/colors working on Password Page
  04/19/2020 [095] Add new share/loan selection method in Transfer Screen
  04/21/2020 [096] Deploy Beta of Major changes in Xfer screen
  04/21/2020 [097] Fix Hidden Acct DLQ/PAY/PAYOFF was showing on amount drop-down
  04/21/2020 [098] Fix issue with [X] banner going to bogus screen (only affected 22000)
  04/27/2020 [099] Re-Write password entry screen - new Read-Only Check Boxes
  04/28/2020 [100] Get Enrollment working
  04/29/2020 [101] Finalize Enrollment
  04/30/2020 [102] Add Cancel Button on Phone Auth screen (is in bottom, but that's hidden now)
  04/30/2020 [103] Fix Enroll to use the correct variable for Account number
  05/02/2020 [104] Get Last4 of Card # on history
  05/04/2020 [105] Temp remove DETAIL button on History and put in production
  05/05/2020 [106] ENTER moves to next field - Not 100% yet and need to test on Mobile
  05/06/2020 [107] Scroll to bottom when Error/Alert/Info message is displayed
  05/07/2020 [108] Fix bug in Scroll to bottom (was being called when not needed)
  05/09/2020 [109] Pick up CU's ABA number in 7702 packet
  05/10/2020 [110] Get Check Images displaying (from CorpOne) - Alloya not tested yet
  05/12/2020 [111] Check Images work from Corp One and Alloya - Also can print them
  05/15/2020 [112] Detect and correct for WS-Socket connection loss
  05/15/2020 [113] Correct "delinquency" in z-loanSummary (was missing "u") Lisa SMW reported
  05/16/2020 [114] p00-signin - Fix wasn't displaying acct SecurityImage sometimes
  05/16/2020 [115] Get Custom Links working (Menu Page 2)
  05/17/2020 [116] Resolve Cross-domain error on Image Requests
  05/17/2020 [117] Get Banner Zone Click working (opens link in new tab)
  05/17/2020 [118] Get Banner Zone Images not violating Cross-Site restrictions
  05/18/2020 [119] Use new method of POP-UP windows to try to prevent popup-blockers
  05/18/2020 [120] Use new method to print statements - Changes in showStmt
  05/19/2020 [121] Support printer friendly share and loan history - print from there
  05/25/2020 [122] Implement Ipay Bill-Pay (not working yet)
  05/26/2020 [123] Ipay Bill-Pay ready for Beta-testing
  05/28/2020 [124] Disable Bill-Pay button on menu, if not active for CU (and disable coop for now)
  05/28/2020 [125] Make buttons more consistent and readable
  05/29/2020 [126] Show version and subdomain in title except for production
  06/05/2020 [127] Allow params to be specified from CU's Embedded Sign-in
  06/17/2020 [128] Use b-dropdown instead of b-form-select for saved accounts dropdown (sign-in)
  06/17/2020 [129] Fix bug when switching between acct w/o image and one w/ image
  06/17/2020 [130] Fix DOB error in Enrollment - Was null
  06/18/2020 [131] Change Signin-drop-down button to variant="link" (non-intrusive arrow down)
  06/19/2020 [132] Retain Send-SMS/Voice status message (was getting cleared off)
  06/19/2020 [133] Blank PW and then Change to Text to prevent Browser Save popup
  06/19/2020 [134] Change PW type to "text" to try to prevent Browser Save Popup (p00-signIn)
  06/26/2020 [135] Get ENROLL flag in c4GetMyCuName request
  06/28/2020 [136] Pull up license disclosure from proper location (ptapp.pt4web.com/documents/)
  06/28/2020 [137] Fix bug in [135] if gets security image
  07/04/2020 [138] Eliminate "Authentication Failed (106)" error (changes store and p00-signin)
  07/06/2020 [139] Show Pushed Message (initial purpose to show program update)
  07/09/2020 [140] Change Enroll to ask for mm/dd/yyyy instead of mm.dd.yyyy
  07/23/2020 [141] Allow email address with . before @ (ie: my.name@gmail.com) enroll.vue
  07/25/2020 [142] Finalize/activate Version Upgrade Notice (if remote browser doesn't auto upgrade)
  07/25/2020 [143] Switch to new drop-down for Amount on Transfer Screen
  07/26/2020 [144] Don't validate xfer if amount > available
  07/26/2020 [145] Add page to setup Transfer Pins
  08/21/2020 [146] Add documentation for Transfers (help)
  08/22/2020 [147] Add Enrollment-Help to the Sign-on page
  08/27/2020 [148] Get Check Images to detect CU is active correctly (changes in c4Proxy also)
  08/29/2020 [149] Add support for external PDF Help files
  09/02/2020 [150] Release to production with internal Xfer-Help (disable PDF help files)
  09/12/2020 [151] Auto-Scroll to help window (on open) on Change-Pass screen
  09/14/2020 [152] Change help wording slightly, per Jennifer - Indiana Lakes
  09/22/2020 [153] Add Pending Holds to beginning of history
  09/23/2020 [154] Implement TRDESC for codes unknown to remote client
  09/24/2020 [155] Fix display of small negative numbers (such as -0.05 and -0.25) in utl.fmtDollar
  09/25/2020 [156] Sort SHARE history
  09/27/2020 [157] Sort LOAN history
  10/13/2020 [158] Save/Recall Searches
  11/22/2020 [159] Preliminary Export History
  11/22/2020 [160] Fix Enroll sometimes not allowed
  11/28/2020 [161] Preliminary Export implementation (not working yet - deployed in 163)
  12/01/2020 [162] temp disable Export - Fix History carry-over
  12/08/2020 [163] Deploy .CSV and .TXT exports
  12/08/2020 [164] Resolve issue with CORS when downloading export
  12/27/2020 [165] Get Coop-Bill-Pay working (Diversified)
  12/28/2020 [166] Pop up Modal warning message for AUTH errors
  01/01/2021 [167] Pop up Modal warning message for Sent Pin Phone # issues
  01/05/2021 [168] Change Diversified Bill Pay to say, "Perfect Pay"
  01/11/2021 [169] Change bad password message to: 'Password incorrect for account: <acct>'
  01/14/2021 [170] Support International Numbers
  01/20/2021 [171] Add total to share and loan headers
  01/22/2021 [172] Refine help for Pin Setup (on sendPin and p03-xferFunds pages)
  01/22/2021 [173] Add HELP for Authorizing every time (on sendPin page)
  01/29/2021 [174] Add support for Read-Only mode
  02/03/2021 [175] Detect bad CU# on URL line and Pop up an error box
  02/23/2021 [176] Support Quicken QIF export
  02/24/2021 [177] Support Quicken QIF+ export
  03/04/2021 [178] Disable Bill-Pay if no DRAFT account
  08/06/2021 [179] Make cuVal=0 (disabled) Read-Only mode (in case they get logged in)
  08/16/2022 [180] Pass mDate to statement routine to block older statements than membership date
  08/17/2022 [181] Clear Statement list before requesting next list
  01/13/2026 [182] Pop up retirement banner
 */

export default new Vuex.Store({
  state: {
    cliVer: '1.0.182', /* 000.00.0000 */
    // How version number gets updated on server
    // When doBuild is run, it creates clientVersion.txt
    // (see grep command in /home/john/branchsoft/perfectTeller-Desktop/ptdesk/doBuild)
    // (do NOT quote the grep command here or grep will include THIS line, causing errors)
    // and clientVersion.txt gets incorporated into the TAR file.
    // if ptDesk.gz gets extracted in ptAlpha or ptBeta, the clientVersion file is ignored
    // jsProxy only reads the file in /home/ptDesk/
    // When the real production version gets extracted, it replaces clientVersion in /home/ptDesk
    pageDesc: { // This is what shows up on the URL line
      0: 'Sign-In',
      1: 'Summary',
      2: 'Bill-Pay',
      3: 'Transfer',
      4: 'History',
      5: 'Search',
      6: 'Authorize',
      7: 'Un-Authorize',
      8: 'Confirm',
      9: 'postResult',
      10: 'selectStatement',
      11: 'displayStatement',
      12: 'selectCU',
      13: 'changePassword',
      14: 'unlockAccount',
      15: 'Enroll',
      16: 'Disclosure',
      17: 'TransferOther',
      18: 'AuthorizePinChange',
      19: 'Setup-Change-Pins',
    },
    appTitle: 'Perfect-Teller', // [126]
    appDesc: 'Perfect-Teller', // [126]
    location: '', // [116] Domain of url (ie: ptapp.pt4web.com)
    subDomain: '', // [126]
    urlParams: '', // [127] Support params specified from CU's embedded sign-in
    fullURL: '',
    connectTimeout: 0, // Timeout count while trying to connect (starts at 50)
    otherPin: false,
    otp: true, // [191] One Time Pin
    otKeyK: '', // [191] temp key Key to use for one time login - Cleared as soon as used
    otKeyV: '', // [191] temp key Value to use for one time login - Cleared as soon as used
    isEdge: false,
    appName: 'Perfect-Teller ptApp',
    cuListSubPage: 0,
    specifiedCUID: '',
    binVer: 0,
    backCount: 0,
    adaMode: false,
    signOutWarn: false,
    showHam: false,
    pgIndex: 0,
    pageHash: 'not-init-yet',
    histCount: 0,
    diag22000: false,
    initLevel: 0, // 0 = Pre-Init / 1 = Init Complete / 2 = Program Used Inited Data
    indexedDBValid: false,
    indexedDB: null,
    createdDB: false,
    idbKeyArr: [], // Temp Storage of indexedDB keys during load
    // Store persistent values in array - Auto store on disk as indexedDB or localStorage
    persist: {},
    returnFromMFA: false,
    accountMFA: '',
    doEnroll: false, // [093]
    siShowFooter: false, // [093]
    seshID: '',
    bfKey: '',
    doSsnFocus: false,
    /*
    device: {
      mobile: '0',
      osName: '',
      navVer: '',
      type: '???',
    },
    */
    exShow: false, // [161] Export Confirm Show
    exTitle: 'Download Export File', // [161] Title for Export Confirm Window
    exMessage: '', // [161] Message for Export Confirm Window
    pmShow: false, // [139]
    pmTitle: '', // [147] Customize Title
    pmMessage: '', // [139] Pushed Message via "gotMessage" from jsProxy
    wmShow: false, // [166]
    wmTitle: '', // [166]
    wmMessage: '', // [166]
    navVer: '',
    sPin: {
      account: '', // SendPin Account #
      type: 0, // SendPin Type
    },
    post: {
      acct: '',
      source: '',
      destin: '',
      amount: '',
      from: '',
      to: '',
    },
    vPhone: '',
    pkAct: '',
    siFormUser: '',
    showMenuButton: false,
    pause: false,
    pingTimer: 0,
    signedIn: false,
    siTime: 0,
    tmOut: 300,
    tOut: 300,
    tOutStr: '5:00',
    pend: false,
    pending: null,
    showUnlockOption: false,
    cun: 0,
    // cux: 0, // number specified on URL after /22000 (not ?cu=22000)
    cuName: '',
    curCun: 0,
    myTenth: 0,
    mySecond: 0,
    myInc10: 0,
    fullPath: '',
    trHigh: 0,
    xfCount: 0,
    xfList: [],
    xfChange: 0,
    xfAvail: 'Available: n/a',
    query: null,
    winSize: {
      W: 0,
      H: 0,
    },
    fonts: {
      factor: 1,
      percent: 100,
      font10: 10,
      font11: 11,
      font12: 12,
      font14: 14,
      font16: 16,
      font18: 18,
      font20: 20,
      font22: 22,
      font24: 24,
      font26: 26,
      font28: 28,
      font30: 30,
      font32: 32,
      font34: 34,
      font36: 36,
      xfont16: 16,
    },
    diagAlert: {
      diagShown: false,
      diagMesg: '',
    },
    seImg: {
      imgBase: 'https://secure.pt4web.com/images/',
      imgValid: false,
      imgCaption: '',
      imgSource: '',
    },
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
      ws: null,
      sub: 'ptserv', // ptserv.pt4web.com
    },
    baseURL: 'ptapp.pt4web.com',
    exportInfo: {
      sourceURL: '',
      destinFile: '',
    },
    member: {
      acct: '',
      name: '',
    },
    mBase: [], // Returned by c4SignIn
    validCU: {}, // Returned by c4GetSecurityImage
    diagList: [
      { time: '', info: '' },
    ],
    cuList: [],
    cuListChangeCount: 0,
    userPass: '',
    showDiagList: false,
    showBanner: false,
    banners: {
      count: 0,
    },
    hasDraft: false, // [178] Don't allow Bill-Pay if no Draft account (Diversified)
    shares: {
      count: 0,
      sar: [],
      header: 'Shares',
      changeCount: 0,
    },
    loans: {
      count: 0,
      lar: [],
      header: 'Loans',
      changeCount: 0,
    },
    atmDesc: [],
    trDesc: [],
    history: {
      acct: 0,
      type: '', // S/D/L
      share: '', // Real share type
      note: 0,
      desc: '',
      head: '',
      direction: 'rev', // Default
      searchDesc: '',
    },
    ssList: {}, // Saved Search List
    histShares: {
      count: 0,
      arr: [],
      header: 'Share History',
      changeCount: 0,
      sortOrder: 0,
      draftCount: 0,
      tranCount: 0,
      dateHeader: 'Date',
      descHeader: 'Description',
    },
    histLoans: {
      count: 0,
      arr: [],
      header: 'Loan History',
      changeCount: 0,
      sortOrder: 0,
      tranCount: 0,
      dateHeader: 'Date',
      descHeader: 'Description',
    },
    histPend: { // [153]
      count: 0,
      arr: [],
      header: 'Pending Transactions',
      changeCount: 0,
    },

    statements: { // Contains only displayed page
      page: 0,
      count: 0,
      arr: [],
      changeCount: 0,
    },
    statementMasterList: { // Contains complete statement list from jsProxy
      count: 0,
      arr: [],
    },
    statementCount: 0,
    statementChangeCount: 0,
    webPageResponse: '',
    alert: {
      show: false,
      error: 0,
      message: '',
    },
    confirm: {
      show: false,
      message: '',
    },
    freqs: {
      M: 'Monthly',
      W: 'Weekly',
      B: 'Bi-Weekly',
      H: 'Half-Monthly',
      S: 'Semi-Monthly',
      A: 'Annually',
      T: 'Twice-Annually',
      Q: 'Quarterly',
      V: 'Monthly(V)',
      R: 'Monthly(R)',
    },
    xfer: {
      acct: 0,
      share: '',
      note: 0,
      amount: '',
    },
    xfs: {
      sourceKey: '',
      sourceFull: '',
      destinKey: '',
      destinFull: '',
      amount: '',
      restore: false,
    },
    baseAmounts: [
      { value: '10.00', text: '$10.00' },
      { value: '20.00', text: '$20.00' },
      { value: '25.00', text: '$25.00' },
      { value: '30.00', text: '$30.00' },
      { value: '40.00', text: '$40.00' },
      { value: '50.00', text: '$50.00' },
      { value: '60.00', text: '$60.00' },
      { value: '75.00', text: '$75.00' },
      { value: '100.00', text: '$100.00' },
      { value: '150.00', text: '$150.00' },
      { value: '200.00', text: '$200.00' },
    ],
    amounts: [],
    accounts: [],
    customLinks: [],
    searchRange: {
      quickHead1: 'Quick 1',
      quickHead2: 'Quick 2',
      quickSelect1: 'Recent 50 Trans',
      quickSelect2: 'Recent 14 Days',
      quickButton1: 'Quick 1<br />Recent 50 Trans',
      quickButton2: 'Quick 2<br />Recent 14 Days',
      selections: [
        { value: 'Recent 50 Trans', text: 'Most Recent 50 Transactions' },
        { value: 'Recent 100 Trans', text: 'Most Recent 100 Transactions' },
        { value: 'Recent 200 Trans', text: 'Most Recent 200 Transactions' },
        { value: 'Recent 7 Days', text: 'Most Recent 7 days' },
        { value: 'Recent 14 Days', text: 'Most Recent 14 days' },
        { value: 'Recent 30 Days', text: 'Most Recent 30 days' },
        { value: 'Recent 60 Days', text: 'Most Recent 60 days' },
        { value: 'Recent 90 Days', text: 'Most Recent 90 days' },
        { value: 'Recent 120 Days', text: 'Most Recent 120 days' },
        { value: 'Recent 150 Days', text: 'Most Recent 150 days' },
        { value: 'Recent 180 Days', text: 'Most Recent 180 days' },
        { value: 'Current Month', text: 'Current Month' },
        { value: 'Prior Month', text: 'Prior Month' },
        { value: '2 Months Ago', text: 'Two Months Ago' },
        { value: 'Current Year', text: 'Current Year' },
        { value: 'Prior Year', text: 'Prior Year' },
      ],
    },
    xsh: 'Select Source',
    xdh: 'Select Destination',
    xferSourceHeader: '',
    xferDestinHeader: '',
    saveUpdated: false,
    saveActPas: true,
    saveAccount: false,
    savePassword: false,
    adlValid: true, // Account Dropdown List
    mfaForm: false,
    mfaKey: null, // [138] Store MFA key from c4GetSecurityImage for use in c4SignIn
    xfr: {
      status: 0,
      fmAcct: '',
      fmType: '',
      fmDesc: '',
      fmOrig: '',
      fmAmnt: '',
      fmBal: '',
      fmError: '',
      toAcct: '',
      toType: '',
      toDesc: '',
      toOrig: '',
      toAmnt: '',
      toInt: '',
      toPrin: '',
      toBal: '',
      toError: '',
      xDesc1: '',
      xDesc2: '',
      xDesc3: '',
      fmAcctName: '',
      toAcctName: '',
    },
    pwChangeOption: '',
    pinHelp: '', // Used by sendPin
    pwdHelp: '', // Used by sendPin
    extRecommended: '', // Used by SendPin
    ditchOldRecommended: '',
    quickenDescArea: '',
    quickenHelpArea: '',
    xferHelp: '', // Used by p03-xferFunds
    enablePinOK: false,
    pwExtended: true, // Used by z-pass - true=32 / false=16
    newPassword: '', // returned from z-pass
    pwValid: false, // returned from z-pass
    FocusChangePW: false, // Used to force z-pass to focus password field
    pw1Rand: '',
    pw2Rand: '',
    resetPinRequester: 0, // Used to force sendPin to require phone # again
    bpBPV: 0,
    cuVal: 0, // [174]
    bp: { // BillPay
      continueEnabled: false,
      provider: '',
      instID: '',
      sessionKey: '',
      url: '',
      params: '',
    },
    wpPin: 0,
    wpIdx: 0,
    wpCount: 0,
    wpResult: false,
    wpOTAcct: 0, // One-Time Acct
    wpOTPin: 0, // One-Time Pin
    wp: { // Xfer Pins from CU
      otVisible: false,
      otHidden: false,
      iPinVisible: '',
      iPinHidden: '',
    },
    othPin: 0, // Matched 'OTHER' by Pin
    othVis: 'n', // Vis Flag for 'OTHER'
    othOtp: 'n', // OTP flag for 'OTHER'
    pdfUrl: '',
    windowSize: {
      width: 0,
      height: 0,
    },
  },
  getters: {
    getExportInfo(state) {
      return state.exportInfo;
    },
    getBaseURL(state) {
      return state.baseURL;
    },
    getQuickenDescArea(state) {
      return state.quickenDescArea;
    },
    getQuickenHelpArea(state) {
      return state.quickenHelpArea;
    },
    getExShow(state) {
      return state.exShow;
    },
    getExTitle(state) {
      return state.exTitle;
    },
    getExMessage(state) {
      return state.exMessage;
    },
    getSavedSearchList(state) {
      return state.ssList;
    },
    getSearchRange(state) {
      return state.searchRange;
    },
    getPdfUrl(state) {
      return state.pdfUrl;
    },
    getWpResult(state) {
      return state.wpResult;
    },
    getWpCount(state) {
      return state.wpCount;
    },
    getWpData(state) {
      return state.wp;
    },
    getWpPin(state) {
      return state.wpPin;
    },
    getWpIdx(state) {
      return state.wpIdx;
    },
    getPmShow(state) {
      return state.pmShow;
    },
    getPmTitle(state) {
      return state.pmTitle;
    },
    getPmMessage(state) {
      return state.pmMessage;
    },
    getWmShow(state) {
      return state.wmShow;
    },
    getWmTitle(state) {
      return state.wmTitle;
    },
    getWmMessage(state) {
      return state.wmMessage;
    },
    getMfaKey(state) { // [138]
      return state.mfaKey;
    },
    getAppTitle(state) {
      return state.appTitle;
    },
    getAppDescription(state) {
      return state.appDesc;
    },
    getCuVal(state) {
      return state.cuVal; // [174]
    },
    getBillPayBPV(state) {
      return state.bpBPV;
    },
    getBillPayVars(state) {
      return state.bp;
    },
    getBillPayContinueEnabled(state) {
      return state.bp.continueEnabled;
    },
    getCustomLinks(state) {
      return state.customLinks;
    },
    getValidCU(state) {
      return state.validCU;
    },
    getPw1Rand(state) {
      return state.pw1Rand;
    },
    getPw2Rand(state) {
      return state.pw2Rand;
    },
    getOtherPin(state) {
      return state.otherPin;
    },
    getResetPinRequester(state) {
      return state.resetPinRequester;
    },
    getFocusChangePW(state) {
      return state.FocusChangePW;
    },
    getXSH(state) {
      return state.xsh; // Xfer Share Header
    },
    getXDH(state) {
      return state.xdh; // Xfer Destin Header
    },
    getXferAvailable(state) {
      return state.xfAvail;
    },
    getSourceHeader(state) {
      return state.xferSourceHeader;
    },
    getDestinHeader(state) {
      return state.xferDestinHeader;
    },
    getNewPassword(state) {
      return state.newPassword;
    },
    getPwValid(state) {
      return state.pwValid;
    },
    getExtendedPwStatus(state) {
      return state.pwExtended;
    },
    getDoSsnFocus(state) {
      return state.doSsnFocus;
    },
    getEnablePinOK(state) {
      return state.enablePinOK;
    },
    getOTP(state) { // [191]
      return state.otp;
    },
    getOneTimeKeyK(state) { // [191]
      return state.otKeyK;
    },
    getOneTimeKeyV(state) { // [191]
      return state.otKeyV;
    },
    getIsEdge(state) {
      return state.isEdge;
    },
    getUnlockOption(state) {
      return state.showUnlockOption;
    },
    getAdaMode(state) {
      return state.adaMode;
    },
    getPwChangeOption(state) {
      return state.pwChangeOption;
    },
    getPinHelp(state) {
      return state.pinHelp;
    },
    getPwdHelp(state) {
      return state.pwdHelp;
    },
    getExtRecommended(state) {
      return state.extRecommended;
    },
    getDitchOldRecommended(state) {
      return state.ditchOldRecommended;
    },
    cuListSubPage(state) {
      return state.cuListSubPage;
    },
    getCuList(state) {
      return state.cuList;
    },
    getCuListChangeCount(state) {
      return state.cuListChangeCount;
    },
    webPageResponse(state) {
      return state.webPageResponse;
    },
    getStatements(state) {
      return state.statements;
    },
    getPersist(state) {
      return state.persist;
    },
    getInitLevel(state) {
      return state.initLevel;
    },
    getSavActPasFlag(state) {
      return state.saveActPas;
    },
    getSaveAcct(state) {
      return state.saveAccount;
    },
    getSavePass(state) {
      return state.savePassword;
    },
    getXFS(state) {
      return state.xfs;
    },
    getXferResult(state) {
      return state.xfr;
    },
    getSiFormUser(state) {
      return state.siFormUser;
    },
    getMfaForm(state) {
      return state.mfaForm;
    },
    getPkAcct(state) {
      return state.pkAct;
    },
    getIndexedDBValid(state) {
      return state.indexedDBValid;
    },
    getIndexedDB(state) {
      return state.indexedDB;
    },
    getShareTranCount(state) {
      return state.histShares.count;
    },
    getHasDraft(state) { // [178]
      return state.hasDraft;
    },
    getLoanTranCount(state) {
      return state.histLoans.count;
    },
    getPendTranCount(state) { // [153]
      return state.histPend.count;
    },
    getAccountsDropListValid(state) {
      return state.adlValid;
    },
    getAccountsList(state) {
      return state.accounts;
    },
    getNavVer(state) {
      return state.navVer;
    },
    getShowDiagList(state) {
      return state.showDiagList;
    },
    getHistCount(state) {
      return state.histCount;
    },
    getSignOutWarn(state) {
      return state.signOutWarn;
    },
    getPageDesc(state) {
      return state.pageDesc;
    },
    getBfKey(state) {
      return state.bfKey;
    },
    getSeshID(state) {
      return state.seshID;
    },
    getAmountsList(state) {
      return state.amounts;
    },
    getXfChange(state) {
      return state.xfChange;
    },
    getXfCount(state) {
      return state.xfCount;
    },
    getXfList(state) {
      return state.xfList;
    },
    getTrHigh(state) {
      return state.trHigh;
    },
    getShowHam(state) {
      return state.showHam;
    },
    getFonts(state) {
      return state.fonts;
    },
    getConfirm(state) {
      return state.confirm;
    },
    getAlert(state) {
      return state.alert;
    },
    getAlertError(state) {
      return state.alert.error;
    },
    getPageIndex(state) {
      return state.pgIndex;
    },
    getShowMenuButton(state) {
      return state.showMenuButton;
    },
    getTimeOut(state) {
      return state.tOut;
    },
    getPauseStatus(state) {
      return state.pause;
    },
    getIsPortrait(state) {
      return state.winSize.H > state.winSize.W;
    },
    getWinSize(state) {
      return state.winSize;
    },
    getCliWidth(state) {
      return state.winSize.W;
    },
    getCliHeight(state) {
      return state.winSize.H;
    },
    getMyTenth(state) {
      return state.myTenth;
    },
    getMySecond(state) {
      return state.mySecond;
    },
    getShowBanner(state) {
      return state.showBanner;
    },
    getSiStatus(state) {
      return state.signedIn;
    },
    getSiTime(state) {
      return state.siTime;
    },
    getDiagAlert(state) {
      return state.diagAlert;
    },
    getAppName(state) {
      return state.appName;
    },
    getAppVer(state) {
      return `ptApp Version ${state.cliVer}`;
    },
    getBinVer(state) {
      return state.binVer;
    },
    getCuNumber(state) {
      return state.cun;
    },
    /* getCuxNumber(state) {
      return state.cux;
    }, */
    getCuName(state) {
      return state.cuName;
    },
    getDiagList(state) {
      return state.diagList;
    },
    getBanners(state) {
      return state.banners;
    },
    getMember(state) {
      return state.member;
    },
    getHScc(state) {
      return state.histShares.changeCount;
    },
    getHLcc(state) {
      return state.histLoans.changeCount;
    },
    getHPcc(state) { // [153]
      return state.histPend.changeCount;
    },
    getSTcc(state) {
      return state.statementChangeCount;
    },
    getHistory(state) {
      return state.history;
    },
    getHistShares(state) {
      return state.histShares;
    },
    getHistLoans(state) {
      return state.histLoans;
    },
    getHistPend(state) { // [153]
      return state.histPend;
    },
    getScc(state) {
      return state.shares.changeCount;
    },
    getLcc(state) {
      return state.loans.changeCount;
    },
    getLoanCount(state) {
      return state.loans.count;
    },
    getShares(state) {
      return state.shares;
    },
    getLoans(state) {
      return state.loans;
    },
    /* getWssUrl(state) {
      return state.wsUrl;
    }, */
    getFullPath(state) {
      return state.fullPath;
    },
    getQuery(state) {
      return state.query;
    },
    getSeImage(state) {
      return state.seImg;
    },
    getSeImageValid(state) {
      return state.seImg.imgValid;
    },
    getReturnFromMFA(state) {
      return state.returnFromMFA;
    },
    getAccountMFA(state) {
      return state.accountMFA;
    },
    getDoEnroll(state) { // [093]
      return state.doEnroll;
    },
    getShowFooter(state) { // [093]
      return state.siShowFooter;
    },
    getPostData(state) {
      return state.post;
    },
  },
  mutations: {
    setValidatePhone(state, value) {
      state.vPhone = value;
    },
    setSearchDesc(state, value) {
      state.history.searchDesc = value;
    },
    async setQuickRange1(state, value) {
      state.searchRange.quickSelect1 = value;
      state.searchRange.quickButton1 =
        `${state.searchRange.quickHead1}<br />${state.searchRange.quickSelect1}`;
      await utl.setQuickRange(this.commit, this.state, 1, value);
      this.commit('pullQuick1');
    },
    async setQuickRange2(state, value) {
      state.searchRange.quickSelect2 = value;
      state.searchRange.quickButton2 =
        `${state.searchRange.quickHead2}<br />${state.searchRange.quickSelect2}`;
      await utl.setQuickRange(this.commit, this.state, 2, value);
      this.commit('pullQuick2');
    },
    pullQuick1(state) {
      utl.diag(`pullQuick1 - select="${state.searchRange.quickSelect1}"`);
    },
    pullQuick2(state) {
      utl.diag(`pullQuick2 - select="${state.searchRange.quickSelect2}"`);
    },
    clrWpResult(state) {
      state.wpResult = false;
    },
    clrSourceHeader(state) { // [144]
      state.xferSourceHeader = this.state.xsh;
    },
    clrDestinHeader(state) { // [144]
      state.xferDestinHeader = this.state.xdh;
    },
    clrExMessage(state) { // [161]
      state.exShow = false;
    },
    clrPmMessage(state) { // [139]
      state.pmShow = false;
    },
    clrWmMessage(state) { // [166]
      state.wmShow = false;
    },
    setMfaKey(state, value) { // [138]
      state.mfaKey = value;
    },
    setPw1Rand(state, value) {
      state.pw1Rand = value;
    },
    setPw2Rand(state, value) {
      state.pw2Rand = value;
    },
    setResetPinRequester(state, value) {
      state.resetPinRequester = value;
    },
    setFocusChangePW(state, value) {
      state.FocusChangePW = value;
    },
    setNewPassword(state, value) {
      state.newPassword = value;
    },
    setPwValid(state, value) {
      state.pwValid = value;
    },
    setExtendedPwStatus(state, value) {
      state.pwExtended = value;
    },
    setDoSsnFocus(state, value) {
      state.doSsnFocus = value;
    },
    setEnablePinOK(state, value) {
      state.enablePinOK = value;
    },
    setSocketSub(state, value) {
      state.socket.sub = value;
      state.baseURL = `${value}.pt4web.com`;
    },
    setOTP(state, value) { // [191]
      state.otp = value;
    },
    setOneTimeKey(state, info) { // [191]
      state.otKeyK = info.key;
      state.otKeyV = info.value;
    },
    clrOneTimeKey(state) { // [191]
      state.otKeyK = null;
      state.otKeyV = null;
    },

    requestDraftImage(state, shInfo) {
      const cuInfo = {};
      cuInfo.item = shInfo.item;
      cuInfo.cun = state.cun;
      cuInfo.acct = state.member.acct;
      cuInfo.share = shInfo.share;
      cuInfo.draft = shInfo.draft;
      cuInfo.draftAcct = shInfo.draftAcct;
      cuInfo.chkAct = shInfo.chkAct;
      cuInfo.chkDgt = shInfo.chkDgt;
      cuInfo.date = shInfo.date;
      cuInfo.time = shInfo.time;
      cuInfo.amt = shInfo.amt;
      cuInfo.amt2 = shInfo.amt2;
      cuInfo.aba = state.mBase.aba;
      cuInfo.location = state.location; // [116]
      cuInfo.rpcName = 'c4GetDraftImage';
      this.commit('sendObjToServer', cuInfo);
      state.histShares.arr[shInfo.item].showDraftButton = false; // Disable Get Draft button
      state.histShares.arr[shInfo.item].explain = true;
      state.histShares.arr[shInfo.item].explainMessage = 'Requesting Image Files...';
    },
    requestShareDetail(state, shInfo) {
      const cuInfo = {};
      cuInfo.cun = state.cun;
      cuInfo.file = shInfo.file;
      cuInfo.tran = shInfo.tran;
      cuInfo.acct = state.member.acct;
      cuInfo.type = state.history.shareType;
      cuInfo.note = 0;
      cuInfo.rpcName = 'c4GetTranDetail';
      this.commit('sendObjToServer', cuInfo);
    },
    requestLoanDetail(state, lnInfo) {
      const cuInfo = {};
      cuInfo.cun = state.cun;
      cuInfo.file = lnInfo.file;
      cuInfo.tran = lnInfo.tran;
      cuInfo.acct = state.member.acct;
      cuInfo.type = 'L';
      cuInfo.note = state.history.note;
      cuInfo.rpcName = 'c4GetTranDetail';
      this.commit('sendObjToServer', cuInfo);
    },
    setAdaMode(state, value) {
      state.adaMode = value;
    },
    setPwChangeOption(state, option) {
      state.pwChangeOption = option;
    },
    removeCuFromList(state, cun) {
      // this.commit('storeDiag', state.cuList[cun]);
      if (typeof state.cuList[cun] !== 'undefined') {
        this.commit('storeDiag', `delete ${cun}`);
        delete state.cuList[cun];
        state.cuListChangeCount += 1;
        utl.delCuName(this.commit, cun);
      }
      // this.commit('storeDiag', state.cuList[cun]);
    },
    selectCuFromList(state, cun) {
      // state.cuList = []; // clear list
      // state.cuList = utl.getCuList(state.persist);
      this.commit('storeDiag', `selectCuFromList: cu=${cun} name=${state.cuList[cun].name}`);
      state.cun = cun;
      state.cuName = state.cuList[cun].name;
      const cuInfo = {};
      cuInfo.cun = cun; // Open the connection to the server
      cuInfo.rpcName = 'c4GetMyCuName';
      this.commit('sendObjToServer', cuInfo);
      // this.commit('requestSavedAccounts');
      state.pgIndex = 0;
      this.commit('setCun', cun);
    },
    delCuFromPersist(state, cun) {
      this.commit('storeDiag', `delCuFromPersist: cu=${cun} name=${state.cuList[cun].name}`);
    },
    removeKey(state, key) {
      this.commit('storeDiag', `removeKey: key='${key}'`);
      localStorage.removeItem(key); // Remove from local storage
      delete state.persist[key]; // Remove from loaded persist array
      const idb = state.indexedDB;
      idb.delete(key); // Removed from Indexed DB (returns before complete)
    },

    setSpecifiedCUID(state, value) {
      state.specifiedCUID = value;
    },
    setCuListSubPage(state, value) {
      state.cuListSubPage = value;
    },
    loadCuList(state) {
      state.cuList = []; // clear list
      state.cuList = utl.getCuList(state.persist);
    },
    requestSavedAccounts(state) {
      const cuInfo = {};
      cuInfo.cun = state.cun;
      const keys = Object.keys(state.persist);
      let key1;
      let key2;
      let match;
      let value1;
      let value2;
      let count = 0;
      for (let i = 0; i < keys.length; i += 1) {
        match = 0;
        key1 = keys[i];
        if (key1.substr(0, 3) === 'a1-') { // User/Acct
          match = 1;
          value1 = state.persist[key1];
          for (let j = 0; j < keys.length; j += 1) {
            key2 = keys[j];
            if (`a2-${key1.substr(3, 8)}` === `${key2.substr(0, 11)}`) { // Matching Password
              match = 2;
              value2 = state.persist[key2];
            }
          }
        }
        if (match === 1) {
          count += 1;
          cuInfo[`A${count}`] = `1,${key1.substr(3, 32)},${value1}`;
        }
        if (match === 2) {
          count += 1;
          cuInfo[`A${count}`] = `2,${key1.substr(3, 32)},${value1},${value2}`;
        }
      }
      cuInfo.rpcName = 'c4DecryptSavedAccounts';
      this.commit('sendObjToServer', cuInfo);
    },
    setInitLevel(state, value) {
      this.state.initLevel = value;
    },
    setIndexedDB(state, value) {
      this.state.indexedDB = value;
      this.state.indexedDBValid = true;
    },
    setCreatedDB(state, value) {
      state.createdDB = value;
    },
    setUserPass(state, value) {
      state.userPass = value;
    },
    setSaveAcct(state, value) {
      state.saveAccount = value;
    },
    setSavePass(state, value) {
      state.savePassword = value;
    },
    setXfsAmount(state, value) {
      // utl.diag(`Set xfs.amount=${value}`);
      state.xfs.amount = value;
    },
    setXfsRestore(state, value) {
      state.xfs.restore = value;
    },
    setFmAcctName(state, value) {
      state.xfr.fmAcctName = value;
    },
    setToAcctName(state, value) {
      state.xfr.toAcctName = value;
    },
    setPostData(state, value) {
      this.state.post = value;
    },
    setReturnFromMFA(state, value) {
      this.state.returnFromMFA = value;
    },
    setAccountMFA(state, value) {
      this.state.accountMFA = value;
    },
    setDoEnroll(state, value) { // [093]
      this.state.doEnroll = value;
    },
    setShowFooter(state, value) { // [093]
      this.state.siShowFooter = value;
    },
    setSiFormUser(state, value) {
      this.state.siFormUser = value;
    },
    setMfaForm(state, value) {
      this.state.mfaForm = value;
    },
    setPkAct(state, value) {
      this.state.pkAct = value;
    },
    setAccountDropDownValid(state, value) {
      this.state.adlValid = value;
    },
    setDiag22000(state, value) {
      this.state.diag22000 = value;
    },
    setHistHead(state, value) {
      state.history.head = value;
    },
    setShowDiagList(state, value) {
      state.showDiagList = value;
    },
    setTestModalPM(state, value) {
      if (value === true) {
        state.pmTitle = 'Message From Server';
        state.pmMessage = 'A new version is available<br />Refresh to upgrade to 0.1.141';
        state.pmShow = true;
      } else {
        state.pmShow = false;
      }
    },
    setModalWarn(state, wm) { // [166] Warning Message (RED title)
      if (wm.show === true) {
        state.wmTitle = wm.title;
        state.wmMessage = wm.message;
        state.wmShow = true;
      } else {
        state.wmShow = false;
      }
    },
    dumpPtData(state) {
      // utl.diag(state.persist);
      const keys = Object.keys(state.persist);
      this.commit('storeDiag', '==========================================================================');
      this.commit('storeDiag', `*** Persist Count = ${keys.length} ***`);
      this.commit('storeDiag', '==========================================================================');
      let key;
      for (let i = 0; i < keys.length; i += 1) {
        key = keys[i];
        this.commit('storeDiagIndent', `${key} -> ${state.persist[keys[i]]}`);
      }
      this.commit('storeDiag', '==========================================================================');
    },
    incHistCount() {
      this.state.histCount += 1;
      // utl.diag(`intHistCount=${state.histCount} - Current Page=${state.pgIndex}`);
    },
    decHistCount(state) {
      if (state.histCount > 0) {
        state.histCount -= 1;
      } else {
        state.histCount = 0;
      }
      // utl.diag(`decHistCount=${state.histCount} - Current Page=${state.pgIndex}`);
    },
    setSignOutWarn(state, value) {
      state.signOutWarn = value;
      if (value === true) {
        // window.scrollTo(0, 0);
      }
    },
    setPageHash(state, pageHash) {
      state.pageHash = pageHash;
    },
    urlPageChange(state) {
      // utl.diag('===========================================================');
      // utl.diag('store->urlPageChange called');
      // utl.diag(`Current history.length=${window.history.length}`);
      const currentHash = location.pathname.split('.').pop();
      const pp = utl.decodeHash(this.commit, this.state, this.state.bfKey, this.state.pageHash);
      const cp = utl.decodeHash(this.commit, this.state, this.state.bfKey, currentHash);
      // utl.diag(`prior-Page=${pp.page}`);
      // utl.diag(`Curnt-Page=${cp.page}`);

      if ((pp.page === 12) && (cp.page === 0)) {
        if (state.cun === 0) {
          this.commit('storeDiag', 'User tried BACK from Activation');
          this.commit('setCuListSubPage', 3); // Activate CU sub page
          this.commit('setPageIndex', 12); // Request CU Number
          return;
        }
      }

      if (cp.page > pp.page) { // Prevent going forward
        // utl.diag('User tried to go forward - Stay on prior page');
        this.commit('setPageIndex', pp.page);
        window.history.back();
      }

      if (cp.page < pp.page) {
        if (this.state.signedIn === false) { // Back from CU Select Screen
          this.commit('setPageIndex', 0);
          this.commit('setCun', this.state.cun); // [090] Update CU Number on URL
        } else {
          // this line may be wrong, but messes up BACK BUTTON logout if changed
          // eslint-disable-next-line
          if (pp.page === 8) {
            this.state.xfs.restore = true; // Back Button from xfer confirm page
          }
          if (cp.page === 0) {
            // Set page 1 while waiting confirmation
            this.commit('setPageIndex', 1);
          } else {
            this.commit('setPageIndex', cp.page);
          }
        }
        this.state.pageHash = currentHash; // update current page hash
        this.commit('decHistCount');
      }

      if (cp.page === 0) {
        // utl.diag('User clicked BACK on the Summary Screen - Log Out');
        this.commit('signOut', false);
      }
    },
    doXfer(state, xfInfo) {
      this.commit('storeDiag', `doXfer:
        Source=${xfInfo.source}
        Destin=${xfInfo.destin}
        Amount=${xfInfo.amount}`);
      this.commit('setConfirmMessage', 'Sending Post request to server...');
      let cuInfo = {};
      cuInfo = xfInfo;
      if ((state.othPin > 0) && (state.othOtp === 'Y')) {
        cuInfo.otpin = state.othPin;
      } else {
        cuInfo.otpin = 0;
      }
      cuInfo.rpcName = 'c4PostXfer';
      this.commit('sendObjToServer', cuInfo);
    },
    getAmounts() {
      // utl.diag('store: getAmounts()');

      this.state.amounts.splice(0, this.state.amounts.length); // Clear original array
      const newArray = [];
      for (let i = 0; i < this.state.baseAmounts.length; i += 1) {
        newArray.push(
          { text: `${this.state.baseAmounts[i].text}`,
            value: `${this.state.baseAmounts[i].value}` });
      }

      const aCnt = this.state.xfCount;
      let saPnt = -1;
      let siPnt = -1;
      let daPnt = -1;
      let diPnt = -1;

      // Find current selected SOURCE and DESTIN accounts
      for (let a = 0; a < aCnt; a += 1) {
        const iCnt = this.state.xfList.arr[a].iCnt;
        for (let i = 0; i < iCnt; i += 1) {
          if (a === 0) {
            if (this.state.xfList.arr[a].items[i].source === true) {
              saPnt = a; // Always ZERO for this
              siPnt = i; // Selected Source Account
            }
          }
          if (this.state.xfList.arr[a].items[i].destin === true) {
            daPnt = a; // Selected Destin Member
            diPnt = i; // Selected Destin (share or loan)
          }
        }
      }
      // utl.diag(`Source: ${saPnt},${siPnt}  Destin: ${daPnt},${diPnt}`);

      if ((daPnt >= 0) && (diPnt >= 0)) { // Destination Account
        const da = this.state.xfList.arr[daPnt].items[diPnt];
        if (da.visi === 'Y') { // [097] Add this check
          if (da.note > 0) { // Loan
            // utl.diag(`Found Note: ${da.note}`);
            if (da.bal > 0) {
              if (da.dlq > 0) {
                // utl.diag(`DLQ = ${da.$dlq}`);
                newArray.unshift(
                  { text: `$${da.$dlq.trim()} Delinquent`, value: `${da.$dlq.trim()}` });
              }
              /* if (da.bal > 0) {
                // utl.diag(`Payoff = ${da.$payoff}`);
                newArray.unshift(
                  { text: `${da.$payoff.trim()} Payoff`, value: `${da.$payoff.trim()}` });
              } */
              if (da.rpay > 0) {
                // utl.diag(`Payment = ${da.$rpay}`);
                newArray.unshift(
                  { text: `$${da.$rpay.trim()} Payment`, value: `${da.$rpay.trim()}` });
              }
              if (da.payoff > 0) {
                // utl.diag(`Payoff = ${da.$payoff}`);
                newArray.unshift(
                  { text: `${da.$payoff.trim()} Payoff`, value: `${da.$payoff.trim()}` });
              }
            }
          } else {
            // eslint-disable-next-line
            if (da.bal < 0) {
              // utl.diag(`NegBal = ${da.$bal}`);
              const getPos = utl.fmtDollar(-da.bal);
              newArray.unshift(
                { text: `$${getPos.trim()} NegBal`, value: `${getPos.trim()}` });
            }
          }
        }
      }

      if ((saPnt >= 0) && (siPnt >= 0)) { // Source Account
        const sa = this.state.xfList.arr[saPnt].items[siPnt];
        if (sa.note > 0) {
          if (sa.avail > 0) {
            newArray.unshift(
              { text: `$${sa.$avail.trim()} Add-On`, value: `${sa.$avail.trim()}` });
          }
        } else { // Share
          // eslint-disable-next-line
          if (sa.avail > 0) {
            newArray.unshift(
              { text: `$${sa.$avail.trim()} Available`, value: `${sa.$avail.trim()}` });
          }
        }
      }
      this.state.amounts = newArray; // Assign new array to original array
    },
    clearXfList(state) {
      state.xfr.toAcctName = '';
      const aCnt = this.state.xfCount;
      for (let a = 0; a < aCnt; a += 1) {
        const iCnt = this.state.xfList.arr[a].iCnt;
        for (let i = 0; i < iCnt; i += 1) {
          state.xfList.arr[a].items[i].source = false;
          state.xfList.arr[a].items[i].destin = false;
        }
      }
      state.xfChange += 1; // make xfer page refresh
    },
    setXfSource(state, xfInfo) {
      const styleSelected = {};
      styleSelected.background = 'palegreen';
      styleSelected.fontweight = 'bold'; // control ignores this
      styleSelected.color = 'white'; // control ignores this
      // utl.diag('setXfSource:');
      // utl.diag(xfInfo);
      state.xfs.sourceKey = xfInfo.key; // Used to restore form.source
      state.xfs.sourceFull = xfInfo.full; // Used to restore form.from
      const aPnt = xfInfo.a;
      const iCnt = this.state.xfList.arr[aPnt].iCnt;
      for (let i = 0; i < iCnt; i += 1) {
        if (state.xfList.arr[aPnt].items[i].key === xfInfo.key) {
          const m = this.state.xfList.arr[aPnt];
          state.xfr.fmAcctName = `${m.acct} ${m.name}`;
          // utl.diag(`Source (${aPnt},${i}) ${state.xfList.arr[aPnt].items[i].full}`);
          state.xfList.arr[aPnt].items[i].source = true;
          state.xfList.arr[aPnt].items[i].sStyle = styleSelected;
          state.xfAvail = `Available: ${state.xfList.arr[aPnt].items[i].$avail}`;
          if (state.xfList.arr[aPnt].items[i].destin === true) {
            state.xfList.arr[aPnt].items[i].destin = false;
            state.xfList.arr[aPnt].items[i].dStyle = ' ';
            state.xferDestinHeader = state.xdh;
            // state.xfAvail = 'Available: n/a';
          }
          state.xferSourceHeader = state.xfList.arr[aPnt].items[i].full;
        } else {
          state.xfList.arr[aPnt].items[i].source = false;
          state.xfList.arr[aPnt].items[i].sStyle = ' ';
        }
      }
      this.commit('getAmounts');
      state.xfChange += 1; // make xfer page refresh
    },
    setXfDestin(state, xfInfo) {
      const styleSelected = {};
      styleSelected.background = 'palegreen';
      styleSelected.fontweight = 'bold'; // control ignores this
      styleSelected.color = 'white'; // control ignores this
      state.xfs.destinKey = xfInfo.key; // Used to restore from.destin
      state.xfs.destinFull = xfInfo.full; // Used to restore from.to
      const aCnt = this.state.xfCount;
      for (let a = 0; a < aCnt; a += 1) {
        const iCnt = this.state.xfList.arr[a].iCnt;
        for (let i = 0; i < iCnt; i += 1) {
          if (state.xfList.arr[a].items[i].key === xfInfo.key) {
            const m = this.state.xfList.arr[a];
            state.xfr.toAcctName = `${m.acct} ${m.name}`;
            // utl.diag(`Destin (${a},${i}) ${state.xfList.arr[a].items[i].full}`);
            state.xfList.arr[a].items[i].destin = true;
            state.xfList.arr[a].items[i].dStyle = styleSelected;
            if (state.xfList.arr[a].items[i].source === true) {
              state.xfList.arr[a].items[i].source = false;
              state.xfList.arr[a].items[i].sStyle = ' ';
              state.xferSourceHeader = state.xsh;
              state.xfAvail = 'Available: n/a';
            }
            state.xferDestinHeader = state.xfList.arr[a].items[i].full;
            const info = {};
            info.aPnt = a;
            info.all = false;
            this.commit('setXfaPnt', info);
          } else {
            state.xfList.arr[a].items[i].destin = false;
            state.xfList.arr[a].items[i].dStyle = ' ';
          }
        }
      }
      this.commit('getAmounts');
      state.xfChange += 1; // make xfer page refresh
    },
    setXfaPnt(state, xfInfo) {
      const aCnt = this.state.xfCount;
      let all = xfInfo.all;
      if (state.xfList.arr[aCnt - 1].expand === true) {
        all = false;
        state.xfList.arr[0].expand = false; // So it will set it to true
      }
      for (let a = 0; a < aCnt; a += 1) {
        if (all === true) {
          state.xfList.arr[a].expand = true; // Expand all accounts
        } else if (state.xfList.arr[a].aPnt === xfInfo.aPnt) {
          // state.xfList.arr[a].expand = !state.xfList.arr[a].expand;
          state.xfList.arr[a].expand = true;
        } else {
          state.xfList.arr[a].expand = false;
        }
      }
      this.commit('setFaFa'); // > or V drop down indicator
      state.xfChange += 1;
    },
    initStatement(state, cuInfo) {
      state.statementCount = 0;
      state.showBanner = false; // Hide banner when pulling up statements
      this.commit('setPageIndex', 10);
      this.commit('sendObjToServer', cuInfo);
    },
    initXfer(state, xfInfo) {
      state.xfCount = 0;
      state.xfList = [];

      this.commit('setPageIndex', 3);
      // state.pgIndex = 3;
      this.commit('setConfirmMessage', 'Requesting Valid Transfer Account List...');
      let cuInfo = {};
      cuInfo = xfInfo;
      cuInfo.rpcName = 'c4GetXferList';
      this.commit('sendObjToServer', cuInfo);
    },
    initChangePass(state, cuInfo) {
      this.commit('setPwChangeOption', 2); // 2=change password
      this.commit('setPageIndex', 13);
      this.commit('storeDiag', `initChangePass: Acct=${cuInfo.acct}`);
    },
    initBillPay(state, cuInfo) {
      this.state.bp.continueEnabled = false;
      this.state.bp.provider = '';
      this.commit('setPageIndex', 2);
      this.commit('storeDiag', `initBillPay: Acct=${cuInfo.acct}`);
      this.commit('sendObjToServer', cuInfo);
    },
    initHist(state, ahInfo) {
      state.histShares.count = -1; // [068]
      state.histLoans.count = -1; // [068]
      state.histPend.count = 0; // [153]
      state.history.acct = ahInfo.acct;
      state.history.type = ahInfo.type;
      state.history.share = ahInfo.share;
      state.history.note = ahInfo.note;
      state.history.desc = ahInfo.desc;
      state.history.direction = ahInfo.direction;
      this.commit('setPageIndex', 4);
      // state.pgIndex = 4;
      /* Send request to server */
      this.commit('setConfirmMessage', `Requesting History for ${ahInfo.desc}...`);
      let cuInfo = {};
      cuInfo = ahInfo;
      cuInfo.rpcName = 'c4GetHistory';
      this.commit('sendObjToServer', cuInfo);
    },
    initExport(state, ahInfo) { // [159]
      // this.commit('setConfirmMessage', `Export History for ${ahInfo.desc}...`);
      let cuInfo = {};
      cuInfo = ahInfo;
      cuInfo.location = this.state.subdomain;
      cuInfo.rpcName = 'c4GetHistory';
      this.commit('sendObjToServer', cuInfo);
    },
    /*
    backClicked(state) {
      state.backCount += 1;
      this.commit('storeDiag', `BackButton Count: ${state.backCount}`);
    },
    */
    //---------------------------------------------------------------------
    // menu:
    menuResult(state, result) {
      let didSomething = false;
      this.commit('storeDiag', `MenuResult: ${result}`);
      const cuInfo = {};
      cuInfo.cun = this.state.cun;
      cuInfo.acct = this.state.member.acct;
      cuInfo.share = ' ';
      cuInfo.note = 0;
      cuInfo.amount = 0;
      cuInfo.desc = '';

      /* PAGE 1 ==================================================== */
      if (result === 11) { // Page 1 Button 1 - Transfer Money
        this.commit('initXfer', cuInfo);
        didSomething = true; // Make sure it doesn't resetTime;
      }

      if (result === 12) { // Page 1 Button 2 - View Statements
        state.statementCount = 0; // [181]
        state.statements.arr = []; // [181]
        state.statementChangeCount = 0; // [181]

        cuInfo.sDate = state.mBase.sDate; // [180] Oldest valid statement date
        // cuInfo.diagMe = `My Diag Info - sDate=${cuInfo.sDate}`;
        cuInfo.rpcName = 'c4GetStatementList';
        this.commit('initStatement', cuInfo);
        didSomething = true; // Make sure it doesn't resetTime;
      }

      if (result === 13) { // Page 1 Button 3 - Change Password
        this.commit('initChangePass', cuInfo);
        didSomething = true; // Make sure it doesn't resetTime;
      }

      if (result === 14) { // Page 1 Button 4 - Bill Pay
        cuInfo.rpcName = 'c4GetBillPay';
        this.commit('initBillPay', cuInfo);
        didSomething = true; // Make sure it doesn't resetTime;
      }

      if (result === 18) { // Page 1 Button 8 - Sign Off
        this.commit('signOut', false);
        didSomething = true;
      }

      /* PAGE 2 ==================================================== */
      // Won't come here unless the button is valid - Page 2 Buttons 1 thru 8
      if (result > 20 && result < 29) {
        didSomething = true;
        const idx = result - 20;
        if (typeof this.state.customLinks[idx] !== 'undefined') {
          if (this.state.customLinks[idx].valid === true) {
            // utl.diag(this.state.customLinks[idx].linkURL);
            // window.open(this.state.customLinks[idx].linkURL, '_blank');
            const newTab = window.open(); // [119]
            newTab.location.href = this.state.customLinks[idx].linkURL; // [119]
          }
        }
      }
      /* PAGE 3 ==================================================== */

      /* PAGE 4 ==================================================== */
      if (result === 48) { // Page 4 Button 8 - Un-Auth page
        this.commit('setPageIndex', 7);
        this.state.xfChange += 1;
        didSomething = true;
      }

      if (didSomething) {
        this.commit('closeHam');
        const x = document.getElementById('hamMenu');
        x.classList.toggle('change');
      } else {
        this.commit('resetTime'); // Didn't do something
      }
    },
    //---------------------------------------------------------------------
    resetServerTimeout(state, actInfo) {
      const cuInfo = {};
      cuInfo.cun = state.cun;
      cuInfo.acct = state.member.acct;
      cuInfo.type = actInfo.type;
      cuInfo.note = actInfo.note;
      if (actInfo.isActive) {
        cuInfo.status = 'Open';
      } else {
        cuInfo.status = 'Close';
      }
      cuInfo.rpcName = 'c4Reset';
      this.commit('sendObjToServer', cuInfo);
    },
    resetTime(state) {
      const cuInfo = {};
      cuInfo.cun = state.cun;
      cuInfo.acct = state.member.acct;
      cuInfo.rpcName = 'c4Reset';
      this.commit('sendObjToServer', cuInfo);
    },
    toggleHam() {
      this.state.showHam = !this.state.showHam;
      const x = document.getElementById('hamMenu');
      x.classList.toggle('change');
    },
    closeHam() {
      this.state.showHam = false;
    },
    clearActiveStatement() {
      if (this.state.statementCount > 0) {
        for (let i = 0; i < this.state.statementCount; i += 1) {
          this.state.statements.arr[i].isActive = false;
          this.state.statements.arr[i].highlight = this.state.statements.arr[i].saveHighlight;
        }
      }
      this.state.statementChangeCount += 1; // Update to trigger sharesSummary to update
    },
    clearActive() {
      if (this.state.shares.count > 0) {
        for (let i = 0; i < this.state.shares.count; i += 1) {
          this.state.shares.sar[i].isActive = false;
        }
      }
      if (this.state.loans.count > 0) {
        for (let i = 0; i < this.state.loans.count; i += 1) {
          this.state.loans.lar[i].isActive = false;
        }
      }
      this.state.shares.changeCount += 1; // Update to trigger sharesSummary to update
      this.state.loans.changeCount += 1; // Update to trigger loansSummery to update
    },
    setActiveShare(state, shInfo) {
      this.commit('clearActive');
      if (state.shares.count > 0) {
        for (let i = 0; i < state.shares.count; i += 1) {
          if (state.shares.sar[i].type === shInfo.type) {
            state.shares.sar[i].isActive = shInfo.isActive;
          }
        }
      }
      this.state.shares.changeCount += 1; // Update to trigger sharesSummary to update
    },
    setActiveLoan(state, lnInfo) {
      this.commit('clearActive');
      if (state.loans.count > 0) {
        for (let i = 0; i < state.loans.count; i += 1) {
          if (state.loans.lar[i].note === lnInfo.note) {
            state.loans.lar[i].isActive = lnInfo.isActive;
          }
        }
      }
      this.state.loans.changeCount += 1; // Update to trigger loansSummary to update
    },
    setShareHighlight(state, shInfo) {
      if (state.shares.count > 0) {
        for (let i = 0; i < state.shares.count; i += 1) {
          if (state.shares.sar[i].type === shInfo.type) {
            state.shares.sar[i].highlight = shInfo.style;
          }
        }
      }
      this.state.shares.changeCount += 1; // Update to trigger sharesSummary to update
    },
    setLoanHighlight(state, lnInfo) {
      if (state.loans.count > 0) {
        for (let i = 0; i < state.loans.count; i += 1) {
          if (state.loans.lar[i].note === lnInfo.note) {
            state.loans.lar[i].highlight = lnInfo.style;
          }
        }
      }
      this.state.loans.changeCount += 1; // Update to trigger loansSummary to update
    },
    clearActiveHistory(state) {
      if (state.histShares.count > 0) {
        for (let i = 0; i < this.state.histShares.count; i += 1) {
          state.histShares.arr[i].isActive = false;
          state.histShares.arr[i].highlight = state.histShares.arr[i].style; // not highlighted
          state.histShares.arr[i].selectBox = '';
        }
      }
      if (state.histLoans.count > 0) {
        for (let i = 0; i < this.state.histLoans.count; i += 1) {
          state.histLoans.arr[i].isActive = false;
          state.histLoans.arr[i].highlight = state.histLoans.arr[i].style; // not highlighted
          state.histLoans.arr[i].selectBox = '';
        }
      }
      if (state.histPend.count > 0) { // [153]
        for (let i = 0; i < this.state.histPend.count; i += 1) {
          state.histPend.arr[i].isActive = false;
          state.histPend.arr[i].highlight = state.histPend.arr[i].style; // not highlighted
          state.histPend.arr[i].selectBox = '';
        }
      }
      state.histShares.changeCount += 1; // trigger shares History to update
      state.histLoans.changeCount += 1; // trigger loans History to update
      state.histPend.changeCount += 1; // trigger Pend List to update
    },
    setActiveShareHistory(state, shInfo) {
      this.commit('clearActiveHistory');
      if (state.histShares.count > 0) {
        for (let i = 0; i < state.histShares.count; i += 1) {
          if ((state.histShares.arr[i].file === shInfo.file) &&
              (state.histShares.arr[i].tran === shInfo.tran)) {
            state.histShares.arr[i].isActive = shInfo.isActive;
            if (shInfo.isActive === true) {
              state.histShares.arr[i].selectBox = 'border: solid 4px red;';
            }
          }
        }
      }
      this.state.histShares.changeCount += 1; // Update to trigger sharesSummary to update
    },
    setActiveLoanHistory(state, lnInfo) {
      this.commit('clearActiveHistory');
      if (state.histLoans.count > 0) {
        for (let i = 0; i < state.histLoans.count; i += 1) {
          if ((state.histLoans.arr[i].file === lnInfo.file) &&
              (state.histLoans.arr[i].tran === lnInfo.tran)) {
            state.histLoans.arr[i].isActive = lnInfo.isActive;
            if (lnInfo.isActive === true) {
              state.histLoans.arr[i].selectBox = 'border: solid 4px red;';
            }
          }
        }
      }
      this.state.histLoans.changeCount += 1; // Update to trigger loansSummary to update
    },

    setStatementHighlight(state, stInfo) {
      state.statements.arr[stInfo.key].highlight = stInfo.style;
      this.state.statementChangeCount += 1; // Update to trigger statements to update
      // this.commit('storeDiag', `setStatement=${stInfo.style}`);
    },
    clrStatementHighlight(state, stInfo) {
      if (state.statements.arr[stInfo.key].isActive === true) {
        state.statements.arr[stInfo.key].highlight =
          state.statements.arr[stInfo.key].activeHighlight;
      } else {
        state.statements.arr[stInfo.key].highlight = stInfo.style;
      }
      //
      this.state.statementChangeCount += 1; // Update to trigger statements to update
      // this.commit('storeDiag', `clrStatement=${stInfo.style}`);
    },
    setStatementSelected(state, stInfo) {
      this.commit('clearActiveStatement');
      state.statements.arr[stInfo.key].highlight = stInfo.style;
      state.statements.arr[stInfo.key].activeHighlight = stInfo.style;
      state.statements.arr[stInfo.key].isActive = true;
      this.state.statementChangeCount += 1; // Update to trigger statements to update
      // this.commit('storeDiag', `selectStatement=${stInfo.style}`);
    },
    setShareHistHighlight(state, shInfo) {
      state.histShares.arr[shInfo.key].highlight = shInfo.style;
      this.state.histShares.changeCount += 1; // Update to trigger shareHistory to update
    },
    setLoanHistHighlight(state, lhInfo) {
      state.histLoans.arr[lhInfo.key].highlight = lhInfo.style;
      this.state.histLoans.changeCount += 1; // Update to trigger loanHistory to update
    },
    setPendHistHighlight(state, ppInfo) { // [153]
      state.histPend.arr[ppInfo.key].highlight = ppInfo.style;
      this.state.histPend.changeCount += 1; // Update to trigger pendHistory to update
    },
    signOut(state, stat) {
      if (this.state.signedIn === true) {
        if (stat === true) {
          this.commit('setShowDiagList', false);
          this.commit('storeDiag', 'signOut(state, true)');
          state.exShow = false; // [161]
          state.pmShow = false;
          state.wmShow = false; // [166]
          state.seshID = '';
          state.showUnlockOption = false;
          state.confirm.show = false;
          state.alert.show = false;
          state.diagAlert.diagShown = false;
          state.signedIn = false;
          // this.commit('setPageIndex', 0);
          state.showMenuButton = false;
          state.showBanner = false;
          state.seImg.imgValid = false;
          state.showHam = false;
          this.siTime = 0;
          state.siShowFooter = false; // [063]
          state.signOutWarn = false;
          state.tOut = this.state.tmOut;
          state.shares.count = 0;
          state.shares.sar = [];
          state.shares.changeCount = 0;
          state.loans.count = 0;
          state.loans.lar = [];
          state.loans.changeCount = 0;
          this.state.appName = `Perfect-Teller - ptApp Version ${state.cliVer}`;
          while (state.histCount > 0) {
            // utl.diag(`Logout Loop: Count=${state.histCount}`);
            window.history.back();
            this.commit('decHistCount');
          }
          this.commit('setPageIndex', 0);

          // update pageHash
          const data = {};
          data.page = 0;
          data.sesh = state.seshID;
          data.opt = 0;
          state.pageHash = utl.encodeHash(state.bfKey, data);

          const cuInfo = {}; // Added 08/08/2019
          cuInfo.cun = state.cun;
          cuInfo.acct = state.member.acct;
          cuInfo.rpcName = 'c4SignOut';
          this.commit('sendObjToServer', cuInfo); // Force reset time (will do 10 seconds)
        } else {
          state.signOutWarn = true;
          // window.scrollTo(0, 0); // 0.0.042 added
          const cuInfo = {};
          cuInfo.cun = state.cun;
          cuInfo.acct = state.member.acct;
          cuInfo.rpcName = 'c4Reset';
          this.commit('sendObjToServer', cuInfo); // Force reset time (will do 10 seconds)
        }
      }
    },
    setConfirmShow(state, value) {
      state.confirm.show = value;
    },
    setConfirmMessage(state, message) {
      state.confirm.message = message;
      state.confirm.show = true;
      utl.scrollToBottom(); // [107]
    },
    clrConfirmMessage(state) {
      state.confirm.show = false;
    },
    clrAlertMessage(state) {
      state.alert.show = false;
      // this.state.alert.error = 0;
    },
    setAlertShow(state, value) { // [108] Don't call scrollToBottom() here
      state.alert.show = value;
    },
    setAlertMessage(state, message) {
      state.alert.message = message;
      state.alert.show = true;
      utl.scrollToBottom(); // [107]
    },
    forcePageIndex(state, value) {
      state.pgIndex = value;
      // utl.diag(`store:forcePageIndex - pgIndex=${state.pgIndex} value=${value}`);
    },
    setPageIndex(state, value) {
      const d = new Date();
      this.state.siTime = Math.floor(d.getTime() / 1000);
      // utl.diag(`store:setPageIndex - pgIndex=${state.pgIndex} value=${value}`);
      if (value > state.pgIndex) {
        state.pgIndex = value;
        const pgState = state.pageDesc[state.pgIndex];
        const data = {};
        data.page = state.pgIndex.toString();
        data.sesh = state.seshID;
        data.opt = 0;
        const pageHash = utl.encodeHash(state.bfKey, data);
        state.pageHash = pageHash;
        // const diagx = `pgPage=${state.pgIndex} URL=${pgState}.${pageHash}`;
        // utl.diag(`Watcher: Add History - ${diagx}`);
        window.history.pushState(pageHash, pgState, `${pgState}.${pageHash}`);
        this.commit('incHistCount');
      } else {
        state.pgIndex = value;
      }
    },
    setShowMenuButton(state, value) {
      state.showMenuButton = value;
    },
    incTimer() { /* Fired every 1/10 second - interval set in main.js */
      if (this.state.pageHash === 'not-init-yet') {
        // const url = 'Sign-In';
        // window.history.replaceState(null, null, url);
        this.state.histCount = 0;
        // utl.diag(`histCount=${this.state.histCount}`);
        const bfRand = Math.floor(Math.random() * Math.floor(999999999));
        this.state.bfKey = sprintf('%09d', bfRand);
        this.state.pageHash = window.location.hash;
        //
        this.state.navVer = navigator.appVersion;
        // this.commit('storeDiag', this.state.navVer);
        // this.state.diagList.push({ time: utl.timestamp(), info: `${this.state.navVer}` });
        /*
        let OSName = 'Unknown OS';
        // utl.diag(`navigator.appVersion: '${navigator.appVersion}'`);
        // utl.diag(`navigator.appName: '${navigator.appName}'`);
        // utl.diag(`navigator.appCodeName: '${navigator.appCodeName}'`);
        if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
        if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS';
        if (navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX';
        if (navigator.appVersion.indexOf('Linux') !== -1) OSName = 'Linux';
        if (navigator.appVersion.indexOf('Android') !== -1) OSName = 'Android';
        this.state.device.osName = OSName;

        let mobile = 'false';
        this.state.device.type = '???';
        if (typeof window.orientation !== 'undefined') {
          this.state.device.mobile = '1'; // Only Mobile devices have Orientation defined
          mobile = 'true';
        }
        if (mobile === true) {
          if (OSName.toLowerCase() === 'macos') this.state.device.type = 'mios';
          if (OSName.toLowerCase() === 'linux') this.state.device.type = 'mand';
          if (OSName.toLowerCase() === 'android') this.state.device.type = 'mand';
          if (OSName.toLowerCase() === 'windows') this.state.device.type = 'mwin';
        } else {
          if (OSName.toLowerCase() === 'macos') this.state.device.type = 'mac';
          if (OSName.toLowerCase() === 'unix') this.state.device.type = 'unix';
          if (OSName.toLowerCase() === 'linux') this.state.device.type = 'lin';
          if (OSName.toLowerCase() === 'windows') this.state.device.type = 'win';
        }
        const typeDiag = `Mobile: ${mobile} OS: ${OSName} Dev: ${this.state.device.type}`;
        */
      }

      let w = window.innerWidth;
      const h = window.innerHeight;
      // let w = document.documentElement.clientWidth;
      // const h = document.documentElement.clientHeight;
      if ((this.state.winSize.W !== w) || (this.state.winSize.H !== h)) {
        this.state.winSize.W = w;
        this.state.winSize.H = h;
        this.state.fonts.w = w;
        this.state.fonts.h = h;
        this.state.fonts.percent = (w / 600) * 100;
        let w2 = w;
        if (w2 > 1100) w2 = 1100; // Limit how large the fonts can get
        if (w2 < 500) w2 = 500; // Limit how small the fonts can get
        if (w > 700) w = 700; // Limit how large the fonts can get
        if (w < 500) w = 500; // Limit how small the fonts can get
        const f = w / 600;
        const x = w2 / 600;
        this.state.fonts.factor = f;
        this.state.fonts.font10 = 10 * f;
        this.state.fonts.font12 = 12 * f;
        this.state.fonts.font14 = 14 * f;
        this.state.fonts.font16 = 16 * f;
        this.state.fonts.xfont16 = 16 * x;
        this.state.fonts.font18 = 18 * f;
        this.state.fonts.font20 = 20 * f;
        this.state.fonts.font22 = 22 * f;
        this.state.fonts.font24 = 24 * f;
        this.state.fonts.font26 = 26 * f;
        this.state.fonts.font28 = 28 * f;
        this.state.fonts.font30 = 30 * f;
        this.state.fonts.font32 = 32 * f;
        this.state.fonts.font34 = 34 * f;
        this.state.fonts.font36 = 36 * f;
      }

      if (this.state.pause !== true) {
        this.state.myTenth += 1;
        this.state.myInc10 += 1;
        if (this.state.myInc10 > 9) {
          this.state.mySecond += 1;
          this.state.myInc10 = 0;
          //--------------------------------------------
          // utl.diag(`Second count = ${this.state.mySecond}`);
          //--------------------------------------------
          if (this.state.signedIn === true) {
            const d = new Date();
            const cuTime = Math.floor(d.getTime() / 1000);
            this.state.tOut = this.state.tmOut;
            if (this.state.siTime > 0) {
              const tx = cuTime - this.state.siTime;
              if (this.state.diag22000 === true) {
                if ((tx === 60) || (tx === 70)) {
                  this.commit('resetTime');
                }
              }
              if (tx < this.state.tmOut) {
                this.state.tOut = this.state.tmOut - tx;
              } else {
                this.commit('signOut', true);
              }
            }
          } else {
            this.state.tOut = this.state.tmOut;
          }
          //--------------------------------------------
          if (this.state.socket.isConnected) {
            this.state.pingTimer += 1;
            if (this.state.signedIn === true) {
              if (this.state.pingTimer > 59) {
                this.state.pingTimer = 0;
                this.commit('sendPing');
              }
            }
            if (this.state.pingTimer > 89) {
              this.state.pingTimer = 0;
              // ws.$disconnect();
              this.commit('socketDisconnect');
            }
          }
        }
      }
      // Timeout while trying to connect to remote server (webSocket)
      if (!this.state.socket.isConnected) {
        if (this.state.connectTimeout > 0) {
          this.state.connectTimeout -= 1;
          if (this.state.connectTimeout === 0) {
            this.commit('setAlertMessage', 'Unable to connect to Server');
            this.commit('storeDiag', 'Unable to connect to Websocket Server');
          }
        }
      }
    },
    //-----------------------------------------------------------
    /*
    async delStorePersist(state, key) {
      const myCommit = this.commit;
      myCommit('storeDiag', `delStorePersist: ${key}`);
      // eslint-disable-next-line
      if (true) {
        const idb = state.indexedDB;
        localStorage.removeItem(key);
        delete state.persist.key;
        myCommit('storeDiag', state.persist.key);
        await idb.delete(key);
        myCommit('storeDiag', '... complete');
        // await utl.delOnePersist(myCommit, state, key);
      }
    },
    */
    async startInit(state) {
      const myCommit = this.commit;
      // myCommit('storeDiag', 'BEGIN - StartInit');
      this.state.appName = `Perfect-Teller - ptApp Version ${state.cliVer}`;

      const thisUrl = window.location.href; // [116] This section Added
      const p1 = thisUrl.indexOf('//');
      const p2 = thisUrl.indexOf('/', p1 + 8);
      const p3 = thisUrl.indexOf('.', p1);
      const p4 = thisUrl.indexOf('?', p1);
      let p5 = thisUrl.indexOf('.com/');
      if (p5 < 0) {
        p5 = thisUrl.indexOf('8080/');
      }

      this.state.location = thisUrl.substring(p1 + 2, p2);
      this.state.subdomain = thisUrl.substring(p1 + 2, p3); // [126]
      if (this.state.subdomain === '192') { // [126]
        this.state.subdomain = 'ptlocal';
      }
      if (this.state.subdomain !== 'ptapp') { // [126]
        const sub = this.state.subdomain.substring(2, 8);
        let title = `pt${sub.substring(0, 1).toUpperCase()}${sub.substring(1, 8)}`;
        if (title === 'ptTired') { title = 'ptRetired'; }
        this.state.appTitle = `${title} ${this.state.cliVer}`;
      }

      if ((p4 < 0) && (p5 > 0)) { // [175] This section added
        const urlCUN = thisUrl.substr(p5 + 5, 6);
        myCommit('storeDiag', `urlCUN: ${urlCUN}`);
        const myCun = parseInt(urlCUN, 10);
        if ((myCun < 13000) || (myCun > 65535)) {
          const t1 = 'Invalid Link Address';
          const l1 = 'The specified Link Address is invalid.<br /><br />';
          const l2 = `Link: ${thisUrl}<br /><br />`;
          const l3 = 'Please contact your Credit Union';
          utl.popWarning(this.commit, t1, `<div>${l1}${l2}${l3}</div>`);
          return;
        }
      }
      this.state.fullURL = thisUrl; // [175] This line added
      myCommit('storeDiag', `URL: ${thisUrl}`);
      myCommit('storeDiag', `Location: ${this.state.location}`); // [116] End section
      myCommit('storeDiag', `subDomain: ${this.state.subdomain}`);
      if (p4 > 0) {
        this.state.urlParams = thisUrl.substr(p4, thisUrl.length);
        myCommit('storeDiag', `urlParams: ${this.state.urlParams}`);
      } else {
        this.state.urlParams = '';
      }

      state.idbValid = false;
      let validIndexedDB = window.indexedDB;
      // validIndexedDB = false; // Temp

      if (/Edge/.test(navigator.userAgent)) {
        this.state.isEdge = true;
        myCommit('storeDiag', 'MS Edge Detected - use LocalStorage');
        validIndexedDB = false;
        state.idbValid = false; // indexedDB doesn't work properly with MS Edge
        // Disable it and use Local Storage
      }

      if (validIndexedDB) {
        state.idbValid = true;
        // myCommit('storeDiag', 'StoreInit-001');
        await utl.openIndexedDB(myCommit, state);
        // myCommit('storeDiag', 'StoreInit-002');
        if ((state.createdDB === true) && (localStorage.length > 1)) {
          // myCommit('storeDiag', 'StoreInit-002-A');
          await utl.migrateLs2iDB(myCommit, state);
          // myCommit('storeDiag', 'StoreInit-002-B');
        }
        // myCommit('storeDiag', 'StoreInit-003');
        // await utl.getAllDbKeys(myCommit, state);
        await utl.readAllDbKeys(myCommit, state);
        // myCommit('storeDiag', 'StoreInit-004');
        await utl.loadAllIDBItems(myCommit, state);
      }
      // myCommit('storeDiag', 'StoreInit-005');
      if (!state.idbValid) {
        myCommit('storeDiag', '*** indexedDB is NOT Available - using LocalStorage instead ***');
        // indexedDB not supported in this browser - load from LocalStorage
        await utl.loadLocalStorage(myCommit, state);
      }
      state.initLevel = 1; // App Init is complete (but not displayed yet)
      // myCommit('storeDiag', 'ENDED - startInit');
      /* const cun = state.persist.cun;
      const cuKey = `cuName-${cun}`;
      myCommit('storeDiag', `cun: ${cun} ${state.persist[cuKey]}`);
      myCommit('storeDiag', `appName: ${state.persist.appName}`); */
      // Setup help screens
      /* this.state.pinHelp = utl.fixNL( // Used by sendPin
        'In order to better protect your account, we require a pin code be received ' +
        'on a phone that is currently defined on your account. This is required for ' +
        "certain options that may allow someone to gain access they shouldn't have. " +
        'You can receive the pin code as either a text message or as a voice call ' +
        'to your phone.\nPlease select which option you prefer and then ' +
        'enter the phone number to send the pin to. If that phone number is not currently ' +
        'defined on your account, you can not send the pin to it.  If the phone number ' +
        'is on your account, but not designated as a mobile number, it will only be able ' +
        'to receive a voice call.  Once you have received the pin, enter it in the ' +
        "Pin field, select the desired option, then click 'OK'."); */

      this.state.pinHelp = utl.fixNL( // Used by sendPin
        'As a security feature, your phone number must be on your Credit Union ' +
        'account so a 6-digit PIN code can be sent either via a phone call or a text message. ' +
        'If you are unable to receive the PIN, please check with your credit union to make' +
        ' sure your phone number is correctly listed on your account. <br /> ' +
        'This feature provides additional security to prevent unauthorized individuals from ' +
        'accessing your account. Select if you wish to receive the PIN via text or a voice call. ' +
        'Once the PIN is received, enter it in the PIN field, ' +
        "then select or enter any requested information. Click 'OK' when finished.");

      this.state.pwdHelp = utl.fixNL( // Used by sendPin
        'All passwords must be at least 8 characters in length.\n' +
        'Extended passwords may be up to 32 characters in length.\n' +
        'NON-Extended passwords are limited to 16 characters in length.\n' +
        'Extended passwords are not compatible with the old versions of Perfect-Teller.\n' +
        'All passwords must contain at least one lower case letter, one upper case letter, ' +
        'one numeric digit, and one special character. No spaces are allowed.\n');
      this.state.extRecommended = utl.fixNL( // Used by sendPin
        'Some members have requested the ability to enter longer passwords. Extended Passwords ' +
        'support a length of up to 32 characters, but are not compatible with the old versions ' +
        'of Perfect-Teller (web, flash, and ptApp in the Apple/Android stores).  If you enter ' +
        'a new password with Extended Password checked, the old version of PT will be disabled ' +
        'and the new password will only work on the new version (2020 and beyond).  If you later ' +
        'change the password and do NOT have the Extended Password box checked, you will re-enable ' +
        'the old version of PT, with the new password.\n' +
        'Extended passwords can be 8 to 32 characters in length.\n' +
        'NON-Extended passwords can be 8 to 16 characters in length.\n');
      this.state.ditchOldRecommended = utl.fixNL( // Used by sendPin
        'NOTE: If you are no longer using the OLD versions of Perfect Teller, it is ' +
        'recommended to always select Extended Passwords, since the new version of ' +
        'Perfect-Teller has additional security features that will help protect your ' +
        'account from unauthorized access and selecting Extended will disable ' +
        'the older versions (including the mobile app).');
      this.state.quickenDescArea = utl.fixNL(
        'This format allows you to Import into newer versions of Quicken if ' +
        'you specify EXACTLY what the Bank Account is called inside Quicken, ' +
        'including any spaces and upper/lower case letters.\n' +
        'This may be "Checking" or "Personal Checking" or whatever you named it.\n' +
        'Quicken will complain with "account does not exist" if you get this wrong.\n' +
        'Click the "Help" button below for Quicken Import Instructions.');
      this.state.quickenHelpArea = utl.fixNL(
        'A little known and undocumented feature of Quicken allows us to ' +
        'import the old QIF format if you specify which Account it needs ' +
        'to be loaded into. These instructions have been verified to work ' +
        'in Quicken 2011 and should also work in previous versions, ' +
        'although the steps may be slightly different. This may also work with Quick Books.<br />' +
        'Once you create and download the QIF file onto your computer, ' +
        'use the following steps in Quicken.<br />' +
        '<ol>' +
        ' <li>BACKUP your current data in Quicken<br />' +
        "    (in case the data isn't imported as expected)</li>" +
        ' <li>Select File -> File Import -> QIF File...</li>' +
        ' <li>Select your QIF file in the top box.</li>' +
        ' <li>Select "All Accounts" in the middle box</li>' +
        ' <li>Check "ONLY Transactions" in bottom box</li>' +
        ' <li>Click "Import" and follow the instructions.</li>' +
        ' <li>Click the [To Do] button (bottom right)<br />to accept the transactions.</li>' +
        '</ol>');
    },

    async saveIndexedDB() {
      // utl.diag(state);
      //
    },
    sendPing(state) {
      const cuInfo = {};
      cuInfo.cun = this.state.cun;
      cuInfo.acct = this.state.member.acct;
      cuInfo.navVer = this.state.navVer;
      cuInfo.rpcName = 'c4Ping';
      if (this.state.socket.ws === null) { // [112] This section added
        this.state.socket.isConnected = false;
        this.commit('storeDiag', 'sendPing() Detected WS = NULL - flag as not connected');
      } else {
        // eslint-disable-next-line
        if (this.state.socket.ws.readyState !== this.state.socket.ws.OPEN) {
          this.state.socket.isConnected = false;
          this.commit('storeDiag',
            'sendPing() Detected loss of WS connection - flag as not connected');
        }
      } // [112] End of section added for WebSocket connection loss detection
      if (this.state.socket.isConnected === true) {
        state.socket.ws.send(JSON.stringify(cuInfo));
      }
    },
    setPauseStatus(state, status) {
      state.pause = status;
    },
    setWinWidth(state, width) {
      state.winSize.w = width;
    },
    setWinHeight(state, height) {
      state.winSize.h = height;
    },
    setShowBanner(state, status) {
      state.showBanner = status;
    },
    setSignedIn(state, status) {
      state.signedIn = status;
      if (status) {
        const d = new Date();
        this.state.siTime = Math.floor(d.getTime() / 1000);
        this.state.appName = 'Perfect-Teller App';
      } else {
        this.state.siTime = 0;
        this.state.appName = `Perfect-Teller - ptApp Version ${state.cliVer}`;
      }
    },
    storeDiag(state, message) {
      const myMessage = `store: ${message}`;
      this.commit('putDiag', myMessage);
    },
    storeDiagIndent(state, message) {
      const myMessage = `____ store: ${message}`;
      this.commit('putDiag', myMessage);
    },
    utlDiag(state, message) { // Called from within calls passed to utl class
      const myMessage = `utl: ${message}`;
      this.commit('putDiag', myMessage);
    },
    putDiag(state, message) {
      state.diagList.push({ time: utl.timestamp(), info: message });
    },
    showDiag(state, message) {
      state.diagAlert.diagMesg = message;
      state.diagAlert.diagShown = true;
    },
    hideDiag(state) {
      state.diagAlert.diagShown = false;
    },
    async setCun(state, cun) {
      const myCommit = this.commit;
      state.adlValid = false;
      // this.commit('storeDiag', `Set CUN=${cun}`);
      if ((cun > 12999) && (cun < 65536)) {
        state.cun = parseInt(cun, 10); // Make sure stored as number
        if (this.state.pgIndex === 0) { // [090] Update CU Number on URL
          const url = `${this.state.cun}`;
          window.history.replaceState(null, null, url);
        }

        // if (state.cun === 22000) state.adlValid = true;
        await utl.setMyPersist(myCommit, state, 'cun', `${cun}`);
        // this.commit('storeDiag', `Update Persist CUN=${cun}`);
      }
    },
    async saveSearch(state, svData) {
      const myCommit = this.commit;
      await utl.setMyPersist(myCommit, state, svData.key, svData.data);
      await utl.readAllDbKeys(myCommit, state);
      await utl.loadAllIDBItems(myCommit, state);
      state.ssList = utl.getSavedSearchList(state.persist);
    },
    async removeSavedSearch(state, key) {
      const myCommit = this.commit;
      this.commit('removeKey', key);
      await utl.readAllDbKeys(myCommit, state);
      await utl.loadAllIDBItems(myCommit, state);
      state.ssList = utl.getSavedSearchList(state.persist);
    },
    async updateSearchList(state) {
      // const myCommit = this.commit;
      // await utl.readAllDbKeys(myCommit, state);
      // await utl.loadAllIDBItems(myCommit, state);
      state.ssList = utl.getSavedSearchList(state.persist);
      // utl.diag(`${Object.keys(state.ssList).length}`);
    },
    // eslint-disable-next-line
    setStorePersist(state, data) {
      // const key = data.key;
      // const value = data.value;
      // utl.diag(`setStorePersist: key: ${key} => ${value}`);
    },
    setAppName(state, appName) {
      utl.setAppName(this.commit, this.state, appName);
      state.appName = appName;
    },
    setCuName(state, cuName) {
      state.cuName = cuName;
    },
    // setCuxNumber(state, cux) {
    // state.cux = cux;
    // },
    setSeImage(state, seImg) {
      state.seImg = seImg;
    },
    putFullPath(state, fullPath) {
      state.fullPath = fullPath;
    },
    putQuery(state, query) {
      state.query = query;
    },
    getDisclosure() {
      const cuInfo = {};
      cuInfo.cun = this.state.cun;
      cuInfo.acct = this.state.member.acct;
      cuInfo.navVer = this.state.navVer;
      cuInfo.rpcName = 'c4RequestDisclosure';
      this.commit('sendObjToServer', cuInfo);
    },

    //-----------------------------------------------------------------------------------
    // Websocket Support
    //-----------------------------------------------------------------------------------
    openWebSocket(state, url) {
      if (state.socket.isConnected !== true) {
        this.commit('storeDiag', `Attempt connect to websocket server: ${url}`);
        state.connectTimeout = 50; // Timeout in 5 seconds
        state.socket.ws = new WebSocket(url);
        state.socket.ws.addEventListener('open', (event) => {
          this.commit('SOCKET_ONOPEN', event);
          this.commit('storeDiag', `Websocket Successfully opened to: ${url}`);
          state.connectTimeout = 0; // Prevent timeout when socket closes normally
        });
        state.socket.ws.addEventListener('message', (myObject) => {
          this.commit('SOCKET_ONMESSAGE', myObject);
          this.commit('storeDiag', 'ws.addEventListener');
        });
      }
    },

    sendObjToServer(state, payLoad) {
      const url = `wss://${state.socket.sub}.pt4web.com/wss`;
      // utl.diag(`WebsocketURL: ${url}`);

      if (state.binVer === 0) {
        const myVer = state.cliVer.split('.');
        state.binVer = sprintf('%03d%02d%04d', myVer[0], myVer[1], myVer[2]);
        // this.commit('storeDiag', state.binVer);
      }
      const pl = payLoad;
      pl.cun = state.cun;
      if (pl.cun === 0) { pl.cun = 10101; }
      pl.ver = state.binVer;
      this.commit('storeDiag', `sendObjToServer - rpc.rpcName='${pl.rpcName}' pl.ver='${pl.ver}'`);
      this.state.pingTimer = 0;
      if (this.state.socket.ws === null) { // [112] This section added
        this.state.socket.isConnected = false;
        this.commit('storeDiag', 'Detected WS = NULL - flag as not connected');
      } else {
        // eslint-disable-next-line
        if (this.state.socket.ws.readyState !== this.state.socket.ws.OPEN) {
          this.state.socket.isConnected = false;
          this.commit('storeDiag', 'Detected loss of WS connection - flag as not connected');
        }
      } // [112] End of section added for WebSocket connection loss detection
      if (this.state.socket.isConnected) {
        this.commit('storeDiag', `send2Server: ${payLoad.rpcName} ${pl.cun}`);
        state.socket.ws.send(JSON.stringify(pl));
      } else {
        this.commit('storeDiag', `queue4Server: ${pl.rpcName} ${pl.cun}`);
        this.state.pend = true;
        this.state.pending = pl;
        this.commit('storeDiag', `Connect2WSS: ${url}`);
        this.commit('openWebSocket', url);
      }
    },
    socketDisconnect(state) {
      this.commit('storeDiag', 'socketDisconnect');
      if (state.socket.isConnected === true) {
        state.socket.ws.close();
        state.socket.isConnected = false;
      }
    },
    /*
    wsConnect() {
      this.commit('storeDiag', 'Connect To WSS');
      this.state.diagList.push({ time: utl.timestamp(), info: `Connect To WSS: ${ws.options}` });
      ws.$connect();
    },
    wsDisconnect() {
      this.commit('storeDiag', 'Disconnect From WSS');
      this.state.diagList.push({ time: utl.timestamp(), info: 'Disconnect From WSS' });
      ws.$disconnect();
    },
    */
    // eslint-disable-next-line
    SOCKET_ONOPEN(state, event) {
      this.commit('storeDiag', 'SOCKET_ONOPEN');
      // this.state.diagList.push({ time: utl.timestamp(), info: 'SOCKET_ONOPEN' });
      state.socket.isConnected = true;
      this.state.pingTimer = 0;
      this.state.appName = `Perfect-Teller - ptApp Version ${state.cliVer}`;
      if (this.state.pend) {
        this.state.pend = false;
        const cuInfo = this.state.pending;
        this.commit('storeDiag', `sendQueuedObjToServer: ${cuInfo.rpcName}`);
        state.socket.ws.send(JSON.stringify(cuInfo));
      }
    },
    // eslint-disable-next-line
    SOCKET_ONCLOSE(state, event) {
      this.commit('storeDiag', 'WS_ONCLOSE');
      // this.state.diagList.push({ time: utl.timestamp(), info: 'WS_ONCLOSE' });
      state.socket.isConnected = false;
    },
    // eslint-disable-next-line
    SOCKET_ONERROR(state, event) {
      this.commit('storeDiag', 'WS_ONERROR');
      this.state.alert.message = 'WSS Failed - Please try later';
      this.state.alert.show = true;
      this.state.cuName = 'Credit Union is unavailable';
      this.state.socket.isConnected = false;
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, jsonObject) {
      // utl.diag('SOCKET_ONMESSAGE() called');
      const myObject = JSON.parse(jsonObject.data);
      // utl.diag(myObject);
      // utl.diag(`rpcName: ${myObject.rpcName}`);
      let rpc = '';
      if (typeof myObject.rpcName !== 'undefined') {
        rpc = myObject.rpcName;
      }
      // utl.diag(`RPC: ${myObject.rpcName}`);
      // state.diagAlert.diagMesg = `RPC: ${myObject.rpcName}`;
      // state.diagAlert.diagShown = true;

      this.commit('storeDiag', `RecvdServer: ${rpc}`);
      // this.state.diagList.push({ time: utl.timestamp(), info: `WS_RESPONSE: ${rpc}` });
      if (myObject.rpcName === 'c4GetMyCuName') {
        this.commit('handleC4GetMyCuName', myObject);
      }
      if (myObject.rpcName === 'c4RequestPin') {
        this.commit('handleC4RequestPin', myObject);
      }
      if (myObject.rpcName === 'c4GetDraftImage') {
        this.commit('handleC4GetDraftImage', myObject);
      }
      if (myObject.rpcName === 'c4ValidatePin') {
        this.commit('handleC4ValidatePin', myObject);
      }
      if (myObject.rpcName === 'c4GetSecurityImage') {
        // utl.diag(`store-c4GetSecurityImage - pkAct=${this.state.pkAct}`);
        this.commit('handleC4SecurityImage', myObject);
      }
      if (myObject.rpcName === 'c4GetBanners') {
        this.state.banners = myObject.banner;
        // utl.diag(myObject.banner);
      }
      if (myObject.rpcName === 'c4SignIn') {
        this.commit('handleC4SignIn', myObject);
      }
      if (myObject.rpcName === 'c4Refresh') {
        this.commit('handleC4SignIn', myObject);
      }
      if (myObject.rpcName === 'c4SignOut') {
        this.commit('handleC4SignOut', myObject);
      }
      if (myObject.rpcName === 'c4GetHistory') {
        this.commit('handleC4History', myObject);
      }
      if (myObject.rpcName === 'c4GetXferList') {
        this.state.otherPin = false;
        this.commit('handleC4XferList', myObject);
      }
      if (myObject.rpcName === 'c4RequestOtherAccount') { // Special for non-defined member
        this.state.otherPin = true;
        this.commit('handleC4XferList', myObject);
      }
      if (myObject.rpcName === 'c4PostXfer') {
        this.commit('handleC4PostXfer', myObject);
      }
      if (myObject.rpcName === 'c4GetStatementList') {
        this.commit('handleC4GetStatementList', myObject);
      }
      if (myObject.rpcName === 'c4RequestHelp') {
        this.commit('handleC4RequestHelp', myObject);
      }
      if (myObject.rpcName === 'c4RequestStatement') {
        this.commit('handleC4RequestStatement', myObject);
      }
      if (myObject.rpcName === 'c4RequestDisclosure') {
        this.commit('handleC4RequestDisclosure', myObject);
      }
      if (myObject.rpcName === 'c4ChangePassword') {
        this.commit('handleC4ChangePassword', myObject);
      }
      if (myObject.rpcName === 'c4SetXferPins') {
        this.commit('handleC4SetXferPins', myObject);
      }
      if (myObject.rpcName === 'c4Reset') {
        const d = new Date();
        this.state.siTime = Math.floor(d.getTime() / 1000);
        if (this.state.signOutWarn === true) {
          this.state.siTime -= 290;
        }
        this.state.tOut = this.state.tmOut;
      }
      if (myObject.rpcName === 'c4DecryptSavedAccounts') {
        this.commit('handleC4DecryptSavedAccounts', myObject);
      }
      if (myObject.rpcName === 'c4VerifyCuNum') {
        this.commit('handleC4VerifyCuNum', myObject);
      }
      if (myObject.rpcName === 'c4RequestEnrollment') {
        this.commit('handleC4RequestEnrollment', myObject);
      }
      if (myObject.rpcName === 'c4GetBillPay') {
        this.commit('handleC4GetBillPay', myObject);
      }
      if (myObject.rpcName === 'gotMessage') {
        this.commit('handleGotMessage', myObject);
      }
      if (myObject.rpcName === 'c4ExportReady') {
        this.commit('handleC4ExportReady', myObject);
      }
    },
    // mutations for reconnect methods
    // eslint-disable-next-line
    SOCKET_RECONNECT(state, count) {
      this.commit('storeDiag', 'WS_RECONNECT');
      // this.state.diagList.push({ time: utl.timestamp(), info: 'WS_RECONNECT' });
    },
    SOCKET_RECONNECT_ERROR(state) {
      this.commit('storeDiag', 'WS_RECONNECT_ERROR');
      // this.state.diagList.push({ time: utl.timestamp(), info: 'WS_RECONNECT_ERROR' });
      state.socket.reconnectError = true;
    },

    //-----------------------------------------------------------------------------------
    // Handlers for packets Received from jsProxy
    //-----------------------------------------------------------------------------------
    handleC4GetBillPay(state, myObject) {
      this.commit('storeDiag', 'handleC4GetBillPay');
      const ar = myObject;
      state.bp.provider = ar.bpProv;
      if (state.bp.provider === 'ipay') {
        state.bp.instID = ar.instID;
        state.bp.sessionKey = ar.sessionKey;
        state.bp.url = `https://www.billpaysite.com/intro.asp?instid=${state.bp.instID}`;
        const params = {};
        params.p1 = state.bp.sessionKey;
        params.op = 'Login';
        params.Method = 'Session';
        state.bp.params = params;
        state.bp.continueEnabled = true;
      }
      if (state.bp.provider === 'coop') {
        state.bp.url = ar.url;
        state.bp.sessionKey = ar.paramData1;
        const params = {};
        params.token = state.bp.sessionKey;
        state.bp.params = params;
        state.bp.continueEnabled = true;
      }
      // utl.diag('handleC4GetBillPay');
      // utl.diag(myObject);
    },

    handleC4RequestEnrollment(state, myObject) {
      this.commit('storeDiag', 'handleC4RequestEnrollment');
      // utl.diag(myObject);
      const rsp = myObject.rsp;

      if (rsp.error > 0) {
        this.state.alert.error = rsp.error;
        const msg = utl.getServerStatus(rsp.error);
        this.commit('clrConfirmMessage');
        this.commit('setAlertMessage', `${msg}`);
      } else {
        this.state.alert.error = 0;
        this.commit('clrAlertMessage');
        this.commit('setConfirmMessage', `Account ${rsp.acct} successfully enrolled - Please Sign In`);
        window.history.back(); // go back from selectCU page to Sign-In page
      }
    },
    handleC4VerifyCuNum(state, ar) {
      this.commit('storeDiag', 'handleC4VerifyCuNum');
      if (ar.status === 0) {
        this.commit('setAlertMessage', `Invalid CU# or CUID: ${state.specifiedCUID}`);
      } else {
        this.commit('clrAlertMessage');
        this.state.cun = ar.base.cun;
        this.commit('setCun', ar.base.cun);
        utl.setCuName(this.commit, this.state, this.state.cun, ar.base.cuName);
        this.state.cuName = ar.base.cuName;
        window.history.back(); // go back from selectCU page to Sign-In page
      }
    },
    handleC4DecryptSavedAccounts(state, ar) {
      state.accounts = [];
      let i = 0;
      if (ar.accts > 0) {
        while (i < ar.accts) {
          state.accounts[i] = {};
          if (ar.acct[i].type > 0) {
            state.adlValid = true;
            state.accounts[i].saveAcct = true;
            state.accounts[i].value = ar.acct[i].user;
            state.accounts[i].text = ar.acct[i].user;
            // Password was optionally saved
            if (ar.acct[i].type > 1) {
              state.accounts[i].savePass = true; // Password was previously saved
              state.accounts[i].pw = ar.acct[i].pass;
            } else {
              state.accounts[i].savePass = false; // Password was NOT previously saved
              state.accounts[i].pw = '';
            }
            // this.commit('storeDiag', `Saved Account: ${state.accounts[i].saveAcct}`);
          }
          i += 1;
        }
      }
    },
    //------------------------------------------------------------------
    handleC4GetStatementList(state, myObject) {
      const months = [
        'zeroOffset', // 0
        'January', // 1
        'February', // 2
        'March', // 3
        'April', // 4
        'May', // 5
        'June', // 6
        'July', // 7
        'August', // 8
        'September', // 9
        'October', // 10
        'November', // 11
        'December']; // 12
      let year = 0;
      let month = 0;
      let typ = '';
      // let type = '';
      const ar = myObject;
      /*
      statements: {
        count: 0,
        arr: [],
        header: 'Statement Month',
        changeCount: 0,
      },
      */

      this.commit('storeDiag', `handleC4GetStatementList - Count=${ar.stateCount}`);
      state.statementCount = 0;
      state.statements.arr = [];
      state.statementChangeCount = 0;
      if (ar.stateCount > 0) {
        const keys = Object.keys(ar.statements);
        const kLen = keys.length;
        for (let i = 0; i < kLen; i += 1) {
          const item = kLen - (i + 1);
          const st = {};
          // if (state.statementCount % 2) {
          if (item % 2) {
            st.style = 'background-color: #ccffff; color: black';
          } else {
            st.style = 'background-color: #fcffc4; color: black';
          }
          st.highlight = st.style;
          st.saveHighlight = st.style;
          st.isActive = false;

          if (item === 0) { // Select first item on list
            const myStyle = 'background-color: blue; color: white';
            st.highlight = myStyle;
            st.activeHighlight = myStyle;
            st.isActive = true;
          }

          year = 1900 + parseInt(ar.statements[i].substr(0, 3), 10);
          month = parseInt(ar.statements[i].substr(3, 2), 10);
          typ = ar.statements[i].substr(5, 1);
          st.enc = ar.statements[i].substr(7);
          /*
          if (typ === 'd') {
            type = 'Draft Statement';
          } else {
            type = 'Quarterly Statement';
          }
          */
          st.keyX = `${year}${utl.padZero(month, 2)}${typ}`;
          // st.key = state.statementCount;
          st.key = item;
          // st.desc = `${months[month]} ${year} ${type}`;
          st.desc = `${year}-${utl.padZero(month, 2)} ${months[month]} Statement`;
          // state.statements.arr[state.statementCount] = st;
          state.statements.arr[item] = st;
          /* this.commit('storeDiag',
            `${state.statementCount} ${st.key} ${st.keyX}='${st.desc}' enc='${st.enc}'`); */
          this.commit('storeDiag',
            `${item} ${st.key} ${st.keyX}='${st.desc}' enc='${st.enc}'`);
          // state.statementCount += 1;
        }
        state.statementCount = kLen;
      } else {
        this.commit('storeDiag', 'No statements available');
      }
    },
    handleC4ChangePassword(state, myObject) {
      const ar = myObject;
      // eslint-disable-next-line
      if (ar.rsp.error > 0) {
        this.state.alert.error = ar.rsp.error;
        const errDesc = utl.getServerStatus(ar.rsp.error);
        this.commit('setAlertMessage', errDesc);
        return;
        // eslint-disable-next-line
      } else {
        this.state.alert.error = 0;
      }
      if (ar.rsp.subt === 1) {
        if (ar.rsp.stat === 1) {
          this.commit('setConfirmMessage', 'Extended Password Successfully Updated');
        } else {
          this.commit('setConfirmMessage', 'OLD-Style Password Updated (Non-Extended)');
        }
      }
      if (ar.rsp.subt === 2) {
        this.commit('setConfirmMessage', 'Account Successfully unlocked at Credit Union');
        state.showUnlockOption = false;
      }
      window.history.back(); // Go back to prior page (summary screen or login page, if forgotten)
    },
    handleC4SetXferPins(state, myObject) {
      const ar = myObject;
      if (ar.rsp.error > 0) {
        this.state.alert.error = ar.rsp.error;
        const errDesc = utl.getServerStatus(ar.rsp.error);
        this.commit('setAlertMessage', errDesc);
        return;
        // eslint-disable-next-line
      } else {
        this.state.alert.error = 0;
      }
      /*
      defstruct RSP_7713_B    ! Response 7713 Request (current pins)
      MAP2 OPTION,B,1       ! 0=READ / WRITE Response
      MAP2 FILL,B,1         ! Not used
      MAP2 VOTP,B,1         ! Visible OneTimePin - 0=no / 1=yes
      MAP2 HOTP,B,1         ! Hidden  OneTimePin - 0=no / 1=yes
      MAP2 VPIN,B,2         ! Pin for Visible Balances
      MAP2 HPIN,B,2         ! Pin for Hidden Balances
      MAP2 WPPIN,B,4        ! Used to validate save packet is valid
      MAP2 WPIDX,B,4        ! Location in WPIN array (probably 1)
      endstruct
      */

      const plPinResult = $spk.build({
        option: 'uint8',
        fill: 'uint8',
        votp: 'uint8',
        hotp: 'uint8',
        vpin: 'uint16',
        hpin: 'uint16',
        wpPin: 'uint32',
        wpIdx: 'uint32',
      });
      const payload = utl.extractPayload(myObject);
      const pl = plPinResult.decode(payload);
      // utl.diag(ar);
      // utl.diag(pl);
      if (pl.option === 0) {
        state.wpPin = pl.wpPin; // Save so we can send back with final PIN Save command
        state.wpIdx = pl.wpIdx; // Save so we can send back with final PIN Save command
        state.wp.otVisible = pl.votp === 2;
        state.wp.otHidden = pl.hotp === 2;
        state.wp.iPinVisible = pl.vpin;
        state.wp.iPinHidden = pl.hpin;
        state.wpCount += 1; // Change count so setupPins watch() will notice
        state.wpResult = false; // Make sure result window isn't popped up
        this.commit('setPageIndex', 19); // Enter/Edit pins
      }
      if (pl.option === 1) {
        state.wpResult = true; // Pop up result window on setupPins screen
        // window.history.back(); // Back to Phone # page
        // window.history.back(); // Back to Transfer Page
        // window.history.back(); // Back to Share/Loan summary page
      }
    },
    handleC4RequestHelp(state, ar) {
      // utl.diag(ar);
      state.pdfUrl = ar.url;
      this.commit('setPageIndex', 16); // Use showPDF Page to display help files
    },
    handleC4RequestStatement(state, myObject) {
      const ar = myObject;
      state.webPageResponse = ar.html;
      this.commit('setPageIndex', 11);
      /*
      const url = ar.url;

      // Create a form
      const mapForm = document.createElement('form');
      mapForm.target = '_blank';
      mapForm.method = 'POST';
      mapForm.action = `${url}?Do_Not_Bookmark`;

      // Create an input
      const mapInput = document.createElement('input');
      mapInput.type = 'text';
      mapInput.name = ar.paramName;
      mapInput.value = ar.paramValue;

      // Add the input to the form
      mapForm.appendChild(mapInput);

      // Add the form to dom
      document.body.appendChild(mapForm);

      // Just submit
      mapForm.submit();
      // window.open(`${url}?${ar.paramName}=${ar.paramValue}`, '_blank');

       */
    },
    handleC4RequestDisclosure(state, myObject) {
      // utl.diag(myObject);
      const ar = myObject;
      state.webPageResponse = ar.dData;
      // this.commit('setPageIndex', 16);
      const licenseURL = `https://${state.location}/documents/enr${state.cun}.pdf`; // [136]
      // utl.diag(`LicenseURL='${licenseURL}'`);
      const newTab = window.open(); // [119]
      newTab.location.href = licenseURL; // [119]
      // window.open(`https://secure.pt4web.com/enr${state.cun}.pdf`, '_blank');
    },
    requestHelp(state, helpFile) {
      this.commit('storeDiag', `requestHelp - helpFile=${helpFile}`);
      state.showBanner = false; // Hide banner when pulling up help files
      const cuInfo = {};
      cuInfo.cun = state.cun;
      cuInfo.helpFile = helpFile;
      cuInfo.rpcName = 'c4RequestHelp';
      this.commit('sendObjToServer', cuInfo);
    },
    openStatement(state, stInfo) {
      const key = utl.findActiveStatement(state);
      if (key === false) {
        this.commit('storeDiag', 'openStatement failed - No statement selected');
        return 52;
      }

      const st = state.statements.arr[key];
      this.commit('storeDiag', `openStatement - Active statement= #${key} => ${st.keyX} ${st.enc}`);
      const cuInfo = {};
      cuInfo.cun = stInfo.cun;
      cuInfo.acct = stInfo.acct;
      cuInfo.key = st.key;
      cuInfo.keyX = st.keyX;
      cuInfo.desc = st.desc;
      cuInfo.enc = st.enc;
      cuInfo.rpcName = 'c4RequestStatement';
      this.commit('sendObjToServer', cuInfo);

      // const sample = 'https://secure.pt4web.com/statements-online/GetStatement.php?SampleStatement';
      // state.webPageResponse = window.open(sample);


      /*
      const xmlhttp = new XMLHttpRequest(); // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp.onreadystatechange = () => {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          // document.getElementById("myDiv").innerHTML = xmlhttp.responseText;
          state.webPageResponse = xmlhttp.responseText;
        }
      };
      // xmlhttp.open('GET', 'https://secure.pt4web.com', true);
      xmlhttp.open('GET', 'https://www.w3schools.com', true);
      xmlhttp.send();
      */
      return 27;
    },
    // eslint-disable-next-line
    handleC4PostXfer(state, myObject) {
      state.confirm.show = false;
      const rsp = myObject.rsp;
      this.commit('storeDiag', `handleC4PostXfer -
            rsp.error=${rsp.error}
            rsp.pkType=${rsp.type}
            rsp.acct=${rsp.acct}`);

      // eslint-disable-next-line
      const plPostResult = $spk.build({
        trSeq: 'uint32',
        trDate: 'uint16',
        trTime: 'uint16',
        fmAcct: 'uint32',
        toAcct: 'uint32',
        fmNote: 'uint32',
        toNote: 'uint32',
        seqID: 'uint32',
        fmType: 'char[1]',
        toType: 'char[1]',
        status: 'uint16',
        fmHead: 'char[76]',
        toHead: 'char[76]',
        fmDesc: 'char[56]',
        toDesc: 'char[56]',
        xDesc1: 'char[64]',
        xDesc2: 'char[64]',
        xDesc3: 'char[64]',
      });
      const payload = utl.extractPayload(myObject);
      const pl = plPostResult.decode(payload);
      // utl.diag(rsp);
      // utl.diag(pl);
      // FROM (Source)
      this.state.xfr.status = pl.status;
      this.state.xfr.fmAcct = pl.fmAcct;
      this.state.xfr.fmType = pl.fmType;
      this.state.xfr.fmError = pl.fmDesc.substr(20, 35);
      this.state.xfr.fmDesc = pl.fmDesc.substr(0, 18);
      this.state.xfr.fmOrig = pl.fmDesc.substr(20, 10);
      this.state.xfr.fmAmnt = pl.fmDesc.substr(32, 10);
      this.state.xfr.fmBal = pl.fmDesc.substr(44, 10);

      // TO (Destination)
      this.state.xfr.toAcct = pl.toAcct;
      this.state.xfr.toType = pl.toType;
      this.state.xfr.toError = pl.toDesc;
      if (pl.toType === 'L') {
        this.state.xfr.toError = pl.fmDesc.substr(18, 35);
        this.state.xfr.toDesc = pl.toDesc.substr(0, 18);
        this.state.xfr.toOrig = pl.toDesc.substr(18, 9);
        this.state.xfr.toInt = pl.toDesc.substr(27, 8);
        this.state.xfr.toPrin = pl.toDesc.substr(35, 9);
        this.state.xfr.toAmnt = this.state.xfr.toPrin; // Set same as Principal
        this.state.xfr.toBal = pl.toDesc.substr(45, 9);
      } else {
        this.state.xfr.toError = pl.fmDesc.substr(20, 35);
        this.state.xfr.toDesc = pl.toDesc.substr(0, 18);
        this.state.xfr.toOrig = pl.toDesc.substr(20, 10);
        this.state.xfr.toAmnt = pl.toDesc.substr(32, 10);
        this.state.xfr.toBal = pl.toDesc.substr(44, 10);
      }

      this.state.xfr.xDesc1 = pl.xDesc1;
      this.state.xfr.xDesc2 = pl.xDesc2;
      this.state.xfr.xDesc3 = pl.xDesc3;
      // this.state.xfr.fmAcctName = was set by setXfSource()
      // this.state.xfr.toAcctName = was set by setXfDestin()
      // window.history.back(); // Go back to main summary screen
      this.commit('setPageIndex', 9); // Then go to page 9 (xfer result)
    },
    // eslint-disable-next-line
    handleC4SignOut(state, myObject) {
      this.commit('storeDiag', 'handleC4SignOut');
      if (state.saveUpdated === true) {
        this.commit('requestSavedAccounts'); // Re-Fetch saved accts in case of change
      }
    },
    handleC4XferList(state, myObject) {
      utl.diag('store - handleC4XferList');
      const rsp = myObject.rsp;
      utl.diag(`store - rsp.error = ${rsp.error}`);
      if (rsp.error === 213) { // Acct or Pin is wrong
        this.state.alert.error = rsp.error;
        // this.commit('setPageIndex', 3); // Switch back to XFER page to show HELP
        window.history.back(); // go back to the XFER page to show HELP
        this.state.xfChange += 1;
        return;
      }
      this.state.xferSourceHeader = this.state.xsh;
      this.state.xferDestinHeader = this.state.xdh;
      this.state.xfCount = 0;
      this.state.xfList = [];
      this.state.xfList.arr = [];
      this.commit('storeDiag', '--------------------------------------------');
      this.commit('storeDiag', `handleC4XferList -
            rsp.error=${rsp.error}
            rsp.pkType=${rsp.type}
            rsp.acct=${rsp.acct}`);

      if (rsp.error > 0) {
        this.state.alert.error = rsp.error;
        this.state.alert.message = utl.getServerStatus(rsp.error);
        this.state.alert.show = true;
        this.state.enablePinOK = false;

        // if (rsp.error === 213) { // Acct or Pin is wrong
        //   this.commit('setPageIndex', 3); // Switch back to XFER page to show HELP
        //   this.state.xfChange += 1;
        // }

        this.commit('setResetPinRequester', rsp.error); // force sendPin to request phone again
        return;
        // eslint-disable-next-line
      } else {
        this.state.alert.error = 0;
      }


      // eslint-disable-next-line
      const plXferTest = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
      });
      // eslint-disable-next-line
      const plXferMember = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'B' */
        vis: 'char[1]',
        otp: 'char[1]',
        acct: 'uint32',
        name: 'char[30]',
        pin: 'uint16',
      });

      // eslint-disable-next-line
      const plXferShare = $spk.build({
        size: 'uint8', // 40
        ident: 'char[1]', /* 'S' */
        type: 'char[1]',
        visi: 'char[1]',
        acct: 'uint32',
        avail: 'int32',
        bal: 'int32',
        desc: 'char[20]',
        vSource: 'uint8',
        vDestin: 'uint8',
      });

      // eslint-disable-next-line
      const plXferLoan = $spk.build({
        size: 'uint8', // 40
        ident: 'char[1]', /* 'L' */
        type: 'char[1]',
        visi: 'char[1]',
        acct: 'uint32',
        note: 'uint32',
        avail: 'uint32',
        bal: 'uint32',
        dpay: 'uint32',
        rpay: 'uint32',
        dlq: 'uint32',
        payoff: 'uint32',
        vSource: 'uint8',
        vDestin: 'uint8',
      });

      // eslint-disable-next-line
      const plXferVisa = $spk.build({
        size: 'uint8', // 40
        ident: 'char[1]', /* 'V' */
        type: 'char[1]', // 'V'
        visi: 'char[1]', // Indicates if there is a valid balance to show
        acct: 'uint32', // Must be main member
        note: 'uint32', // How we indicate which was selected by member
        avail: 'uint32', // Not supported yet, but maybe future
        bal: 'uint32', // Not supported yet, but maybe future
        desc: 'char[12]', // Visa Card, HSA-Visa, HE-Visa
        vSource: 'uint8', // Should always be no, but open for future change
        vDestin: 'uint8', // Will always be Yes (won't exist if not valid destination)
      });

      if (myObject.plSize > 0) {
        const payload = utl.extractPayload(myObject);
        let ptr = 0;
        const plData = {};
        plData.plXferMember = plXferMember;
        plData.plXferShare = plXferShare;
        plData.plXferLoan = plXferLoan;
        plData.plXferVisa = plXferVisa;
        //
        let itemCount = 0;
        while (ptr < myObject.plSize) {
          const pl = plXferTest.decode(payload.slice(ptr, ptr + 2));
          plData.subPacket = payload.slice(ptr, ptr + pl.size);
          // this.commit('storeDiag', `ptr: ${ptr} Size: ${pl.size} Ident: ${pl.ident}`);
          if (pl.ident === 'M') this.commit('extractXferMember', plData);
          if (pl.ident === 'S') this.commit('extractXferShare', plData);
          if (pl.ident === 'L') this.commit('extractXferLoan', plData);
          if (pl.ident === 'V') this.commit('extractXferVisa', plData);
          ptr += pl.size;
          itemCount += 1;
          if (itemCount > 1024) { // Just in case
            utl.diag('XferList - Too Many items - Aborting');
            break;
          }
        }
      }
      this.commit('getAmounts');
      this.commit('setFaFa'); // > or V drop down indicator
      this.commit('setConfirmShow', false); // Hide "Requesting..." message
      state.xfAvail = 'Available: n/a';
      if (state.otherPin === true) {
        window.history.back(); // go back from OTHER Acct page
      }
      this.commit('setPageIndex', 3);
      this.state.xfChange += 1;
    },
    setFaFa() { // > or V drop down indicator
      if (this.state.xfCount > 0) {
        for (let a = 0; a < this.state.xfCount; a += 1) {
          const m = this.state.xfList.arr[a];
          if (m.expand === true) {
            this.state.xfList.arr[a].destHead = `▼ ${m.acct} ${m.name} ${m.iCnt} accounts`;
          } else {
            this.state.xfList.arr[a].destHead = `▶ ${m.acct} ${m.name} ${m.iCnt} accounts`;
          }
        }
      }
    },
    extractXferMember(state, plData) {
      const m = plData.plXferMember.decode(plData.subPacket);
      // utl.diag('extractXferMember:');
      // utl.diag(m);
      if (this.state.otherPin === true) {
        state.othPin = m.pin;
        state.othVis = m.vis;
        state.othOtp = m.otp;
        // utl.diag(`OTHER-Member - Pin=${m.pin} Vis="${m.vis}" Otp="${m.otp}"`);
      } else {
        state.othPin = 0;
        state.othVis = 'n';
        state.othOtp = 'n';
        // utl.diag('OTHER-Member - NOT SPECIFIED');
      }
      this.state.xfCount += 1;
      const aPnt = this.state.xfCount - 1;
      this.state.xfList.arr[aPnt] = [];
      this.state.xfList.arr[aPnt].aPnt = aPnt;
      this.state.xfList.arr[aPnt].acct = m.acct;
      this.state.xfList.arr[aPnt].name = m.name;
      this.state.xfList.arr[aPnt].expand = (m.acct === this.state.member.acct);
      this.state.xfList.arr[aPnt].iCnt = 0;
      this.state.xfList.arr[aPnt].items = [];
      // this.commit('storeDiag', `***** ${m.acct} ${m.name} *****`);
    },
    extractXferShare(state, plData) {
      const s = plData.plXferShare.decode(plData.subPacket);
      const aPnt = this.state.xfCount - 1;
      this.state.xfList.arr[aPnt].iCnt += 1;
      const iPnt = this.state.xfList.arr[aPnt].iCnt - 1;
      this.state.xfList.arr[aPnt].items[iPnt] = [];
      this.state.xfList.arr[aPnt].items[iPnt].aPnt = aPnt;
      this.state.xfList.arr[aPnt].items[iPnt].iPnt = iPnt;
      this.state.xfList.arr[aPnt].items[iPnt].source = false;
      this.state.xfList.arr[aPnt].items[iPnt].destin = false;
      this.state.xfList.arr[aPnt].items[iPnt].sStyle = ' ';
      this.state.xfList.arr[aPnt].items[iPnt].dStyle = ' ';
      this.state.xfList.arr[aPnt].items[iPnt].visi = s.visi;
      this.state.xfList.arr[aPnt].items[iPnt].key = `${utl.padZero(s.acct, 10)}${s.type}${utl.padZero(0, 7)}`;
      this.state.xfList.arr[aPnt].items[iPnt].acct = s.acct;
      this.state.xfList.arr[aPnt].items[iPnt].type = s.type;
      this.state.xfList.arr[aPnt].items[iPnt].note = '';
      this.state.xfList.arr[aPnt].items[iPnt].avail = s.avail;
      this.state.xfList.arr[aPnt].items[iPnt].bal = s.bal;
      this.state.xfList.arr[aPnt].items[iPnt].dpay = '';
      this.state.xfList.arr[aPnt].items[iPnt].rpay = '';
      this.state.xfList.arr[aPnt].items[iPnt].dlq = '';
      this.state.xfList.arr[aPnt].items[iPnt].payDest = '';
      this.state.xfList.arr[aPnt].items[iPnt].src = true;
      this.state.xfList.arr[aPnt].items[iPnt].$avail = utl.fmtDollar(s.avail);
      this.state.xfList.arr[aPnt].items[iPnt].$availDest = utl.fmtDollar(s.avail);
      this.state.xfList.arr[aPnt].items[iPnt].$bal = utl.fmtDollar(s.bal);
      this.state.xfList.arr[aPnt].items[iPnt].$balDest = utl.fmtDollar(s.bal);
      this.state.xfList.arr[aPnt].items[iPnt].$dpay = '';
      this.state.xfList.arr[aPnt].items[iPnt].$rpay = '';
      this.state.xfList.arr[aPnt].items[iPnt].$dlq = '';
      this.state.xfList.arr[aPnt].items[iPnt].desc = utl.toTitleCase2(s.desc);
      this.state.xfList.arr[aPnt].items[iPnt].full = `${s.acct} ${utl.toTitleCase2(s.desc)}`;
      this.state.xfList.arr[aPnt].items[iPnt].fullx = `${s.acct} ${utl.toTitleCase2(s.desc)}`;
      this.state.xfList.arr[aPnt].items[iPnt].vSource = s.vSource;
      // this.state.xfList.arr[aPnt].items[iPnt].vSource = 0;
      this.state.xfList.arr[aPnt].items[iPnt].vDestin = s.vDestin;
      if (s.visi !== 'Y') {
        this.state.xfList.arr[aPnt].items[iPnt].$availDest = 'Hidden';
        this.state.xfList.arr[aPnt].items[iPnt].$balDest = 'Hidden';
      }
    },
    extractXferLoan(state, plData) {
      const l = plData.plXferLoan.decode(plData.subPacket);
      const aPnt = this.state.xfCount - 1;
      this.state.xfList.arr[aPnt].iCnt += 1;
      const iPnt = this.state.xfList.arr[aPnt].iCnt - 1;
      this.state.xfList.arr[aPnt].items[iPnt] = [];
      this.state.xfList.arr[aPnt].items[iPnt].aPnt = aPnt;
      this.state.xfList.arr[aPnt].items[iPnt].iPnt = iPnt;
      this.state.xfList.arr[aPnt].items[iPnt].source = false;
      this.state.xfList.arr[aPnt].items[iPnt].destin = false;
      this.state.xfList.arr[aPnt].items[iPnt].sStyle = ' ';
      this.state.xfList.arr[aPnt].items[iPnt].dStyle = ' ';
      this.state.xfList.arr[aPnt].items[iPnt].visi = l.visi;
      this.state.xfList.arr[aPnt].items[iPnt].key = `${utl.padZero(l.acct, 10)}L${utl.padZero(l.note, 7)}`;
      this.state.xfList.arr[aPnt].items[iPnt].acct = l.acct;
      this.state.xfList.arr[aPnt].items[iPnt].type = 'L';
      this.state.xfList.arr[aPnt].items[iPnt].note = l.note;
      this.state.xfList.arr[aPnt].items[iPnt].avail = l.avail;
      this.state.xfList.arr[aPnt].items[iPnt].bal = l.bal;
      this.state.xfList.arr[aPnt].items[iPnt].dpay = l.dpay;
      this.state.xfList.arr[aPnt].items[iPnt].rpay = l.rpay;
      this.state.xfList.arr[aPnt].items[iPnt].dlq = l.dlq;
      this.state.xfList.arr[aPnt].items[iPnt].payoff = l.payoff;
      this.state.xfList.arr[aPnt].items[iPnt].vSource = l.vSource;
      this.state.xfList.arr[aPnt].items[iPnt].vDestin = l.vDestin;
      this.state.xfList.arr[aPnt].items[iPnt].payDest = utl.fmtDollar(l.dpay);
      if (l.dlq > 0) {
        this.state.xfList.arr[aPnt].items[iPnt].payDest = `Dlq: ${utl.fmtDollar(l.dlq)}`;
      }
      this.state.xfList.arr[aPnt].items[iPnt].src = (l.avail > 0);
      this.state.xfList.arr[aPnt].items[iPnt].$avail = utl.fmtDollar(l.avail);
      this.state.xfList.arr[aPnt].items[iPnt].$bal = utl.fmtDollar(l.bal);
      this.state.xfList.arr[aPnt].items[iPnt].$balDest = utl.fmtDollar(l.bal);
      this.state.xfList.arr[aPnt].items[iPnt].$dpay = utl.fmtDollar(l.dpay);
      this.state.xfList.arr[aPnt].items[iPnt].$rpay = utl.fmtDollar(l.rpay);
      this.state.xfList.arr[aPnt].items[iPnt].$dlq = utl.fmtDollar(l.dlq);
      this.state.xfList.arr[aPnt].items[iPnt].$payoff = utl.fmtDollar(l.payoff);
      this.state.xfList.arr[aPnt].items[iPnt].desc = `Note # ${l.note}`;
      this.state.xfList.arr[aPnt].items[iPnt].full = `${l.acct} Note # ${l.note}`;
      if ((l.dlq > 0) && (l.visi === 'Y')) { // Don't show DLQ if balances are hidden
        this.state.xfList.arr[aPnt].items[iPnt].fullx = `${l.acct} Note # ${l.note} DLQ`;
      } else {
        this.state.xfList.arr[aPnt].items[iPnt].fullx = `${l.acct} Note # ${l.note}`;
      }
      if (l.visi !== 'Y') {
        this.state.xfList.arr[aPnt].items[iPnt].payDest = 'Hidden';
        this.state.xfList.arr[aPnt].items[iPnt].$balDest = 'Hidden';
      }
    },

    extractXferVisa(state, plData) {
      const v = plData.plXferVisa.decode(plData.subPacket);
      const aPnt = this.state.xfCount - 1;
      this.state.xfList.arr[aPnt].iCnt += 1;
      const iPnt = this.state.xfList.arr[aPnt].iCnt - 1;
      this.state.xfList.arr[aPnt].items[iPnt] = [];
      // v.visi = 'N';
      this.state.xfList.arr[aPnt].items[iPnt].aPnt = aPnt;
      this.state.xfList.arr[aPnt].items[iPnt].iPnt = iPnt;
      this.state.xfList.arr[aPnt].items[iPnt].source = false;
      this.state.xfList.arr[aPnt].items[iPnt].destin = false;
      this.state.xfList.arr[aPnt].items[iPnt].sStyle = ' ';
      this.state.xfList.arr[aPnt].items[iPnt].dStyle = ' ';
      this.state.xfList.arr[aPnt].items[iPnt].visi = v.visi; // Indicates if valid balance
      this.state.xfList.arr[aPnt].items[iPnt].key = `${utl.padZero(v.acct, 10)}#${utl.padZero(v.note, 7)}`;
      this.state.xfList.arr[aPnt].items[iPnt].acct = v.acct;
      this.state.xfList.arr[aPnt].items[iPnt].type = 'V';
      this.state.xfList.arr[aPnt].items[iPnt].note = v.note;
      this.state.xfList.arr[aPnt].items[iPnt].avail = v.avail;
      this.state.xfList.arr[aPnt].items[iPnt].bal = v.bal;
      this.state.xfList.arr[aPnt].items[iPnt].src = (v.avail > 0);
      this.state.xfList.arr[aPnt].items[iPnt].$avail = utl.fmtDollar(v.avail);
      this.state.xfList.arr[aPnt].items[iPnt].$bal = utl.fmtDollar(v.bal);
      this.state.xfList.arr[aPnt].items[iPnt].$balDest = utl.fmtDollar(v.bal);
      this.state.xfList.arr[aPnt].items[iPnt].desc = v.desc;
      this.state.xfList.arr[aPnt].items[iPnt].vSource = v.vSource;
      this.state.xfList.arr[aPnt].items[iPnt].vDestin = v.vDestin;
      this.state.xfList.arr[aPnt].items[iPnt].full = `${v.acct} ${v.desc}`;
      this.state.xfList.arr[aPnt].items[iPnt].fullx = `${v.acct} ${v.desc}`;
      this.state.xfList.arr[aPnt].items[iPnt].payDest = 'N/A';
      if (v.visi !== 'Y') {
        this.state.xfList.arr[aPnt].items[iPnt].$balDest = 'N/A';
      }
    },

    //------------------------------------------------------------------
    handleC4History(state, myObject) {
      const rsp = myObject.rsp;
      this.commit('storeDiag', '--------------------------------------------');
      state.histShares.count = 0;
      state.histShares.arr = [];
      state.histShares.dateHeader = 'Date'; // Default Date Order Header
      state.histShares.header = 'Share History';
      state.histShares.changeCount = 0;
      state.histShares.descHeader = 'Description';
      state.histShares.sortOrder = 0; // Reverse Date
      state.histShares.draftCount = 0; // How many drafts did we find?
      state.histShares.tranCount = 0; // How many total transactions
      state.histLoans.count = 0;
      state.histLoans.arr = [];
      state.histLoans.dateHeader = 'Date'; // Default Date Order Header
      state.histLoans.header = 'Loan History';
      state.histLoans.changeCount = 0;
      state.histLoans.descHeader = 'Description';
      state.histLoans.sortOrder = 0; // Reverse Date
      state.histLoans.tranCount = 0; // How many total transactions
      state.histPend.count = 0; // [153]
      state.histPend.arr = []; // [153]
      state.histPend.header = 'Pending Transactions'; // [153]
      state.histPend.changeCount = 0; // [153]

      if (rsp.error > 0) {
        this.state.alert.error = rsp.error;
        this.state.alert.message = utl.getServerStatus(rsp.error);
        this.state.alert.show = true;
        return;
        // eslint-disable-next-line
      } else {
        this.state.alert.error = 0;
      }
      // eslint-disable-next-line
      const plHistTest = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
      });
      // eslint-disable-next-line
      const plHistBase = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'B' */
        trcnt: 'uint8',
        trdcnt: 'uint8',
        atmcnt: 'uint8',
        type: 'char[1]',
        even: 'uint16',
        note: 'uint32',
        oeDate: 'uint16',
        oeTime: 'uint16',
        oeID: 'uint16',
        startRec: 'uint16',
      });

      // eslint-disable-next-line
      const plHistShare = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'S' */
        card: 'uint16',
        file: 'uint16',
        tran: 'uint16',
        dte: 'uint16',
        tme: 'uint16',
        dft: 'uint32',
        amt: 'int32',
        bal: 'int32',
        code: 'uint16',
        atm: 'uint16',
      });

      // eslint-disable-next-line
      const plHistLoan = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'L' */
        even: 'uint16',
        file: 'uint16',
        tran: 'uint16',
        dte: 'uint16',
        tme: 'uint16',
        amt: 'int32',
        fc: 'int32',
        pri: 'int32',
        bal: 'int32',
        code: 'uint16',
        atm: 'uint16',
      });

      // eslint-disable-next-line
      const plHistPend = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'P' */
        card: 'uint16',
        pendType: 'char[1]',
        evenUP: 'uint8',
        remainHR: 'uint8',
        remainMI: 'uint8',
        dte: 'uint16',
        tme: 'uint16',
        dft: 'uint32',
        amt: 'int32',
        code: 'uint16',
        atm: 'uint16',
        bal: 'int32',
        fill: 'char[4]',
      });

      /* Only exists for tran codes beyond what TRNUM knows */
      // eslint-disable-next-line
      const plHistDesc = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'T' */
        code: 'uint16',
        desc: 'char[40]', /* [154] Up to 40 - Probably 25 */
        null: 'uint8',
        fill: 'char[3]',
      });

      // eslint-disable-next-line
      const plHistATM = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'A' */
        code: 'uint16',
        desc: 'char[48]',
        null: 'uint8',
        fill: 'uint8',
        fill2: 'uint16',
        fill4: 'char[8]',
      });

      // eslint-disable-next-line
      const plHistURL = $spk.build({
        size: 'uint8',
        ident: 'char[1]', /* 'U' */
        // https: 'char[46]', // Path of URL
        fname: 'char[24]', // Filename of temp hist file
        md5sum: 'char[32]', // MD5 hash of temp hist file
        fill: 'uint16', // Not used yet
        fsize: 'uint32', // Size of temp hist file
      });

      if (myObject.plSize > 0) {
        const payload = utl.extractPayload(myObject);
        let ptr = 0;
        const plData = {};
        plData.plHistBase = plHistBase;
        plData.plHistShare = plHistShare;
        plData.plHistLoan = plHistLoan;
        plData.plHistPend = plHistPend;
        plData.plHistDesc = plHistDesc;
        plData.plHistATM = plHistATM;
        plData.plHistURL = plHistURL;
        //
        let itemCount = 0;
        while (ptr < myObject.plSize) {
          const pl = plHistTest.decode(payload.slice(ptr, ptr + 2));
          plData.subPacket = payload.slice(ptr, ptr + pl.size);
          // this.commit('storeDiag', `ptr: ${ptr} Size: ${pl.size} Ident: ${pl.ident}`);
          // utl.diag(`storeDiag: ptr: ${ptr} Size: ${pl.size} Ident: ${pl.ident}`);
          if (pl.ident === 'B') this.commit('extractHistBase', plData);
          if (pl.ident === 'S') this.commit('extractHistShare', plData);
          if (pl.ident === 'L') this.commit('extractHistLoan', plData);
          if (pl.ident === 'P') this.commit('extractHistPend', plData);
          if (pl.ident === 'T') this.commit('extractHistDesc', plData); // [154]
          if (pl.ident === 'A') this.commit('extractHistATM', plData);
          if (pl.ident === 'U') this.commit('extractHistURL', plData);
          ptr += pl.size;
          itemCount += 1;
          if (itemCount > 2048) { // Just in case
            utl.diag('History - Too Many items - Aborting');
            break;
          }
        }
        if (state.history.direction === 'fwd') {
          if (state.history.share === 'L') {
            this.state.histLoans.sortOrder = 0; // Tell is sorted REV so Sort Forward
            this.commit('sortLoanDate');
          } else {
            this.state.histShares.sortOrder = 0; // Tell is sorted REV so Sort Forward
            this.commit('sortShareDate');
          }
        }
      } else {
        // msg = `No Payload to Extract - plSize=${myObject.plSize}`;
        // this.commit('putDiag', msg);
      }
      this.commit('setConfirmShow', false); // Hide "Requesting..." message
      this.commit('setPageIndex', 4);
    },
    extractHistBase(state, plData) {
      const b = plData.plHistBase.decode(plData.subPacket);
      state.history.shareType = b.type;
      state.history.share = 'Share Name';
      state.history.note = b.note;
      state.history.type = 'S';
      state.history.share = b.type;
      if (b.type === 'D') state.history.type = 'D';
      if (b.type === 'P') state.history.type = 'D';
      if (b.type === 'L') state.history.type = 'L';
      this.commit('storeDiag', `TranCount: ${b.trcnt} trDescCount: ${b.trdcnt} atmCount: ${b.atmcnt}`);
      this.commit('storeDiag', `TranType: ${state.history.type}
        ShareType ${state.history.share}
        Note: ${state.history.note}`);
    },
    extractHistShare(state, plData) {
      const sh = plData.plHistShare.decode(plData.subPacket);
      sh.dateSortKey = `${utl.padZero(sh.file, 5)}${utl.padZero(sh.tran, 5)}`;
      if (state.histShares.count % 2) {
        sh.style = 'background-color: #ccffff; color: black';
      } else {
        sh.style = 'background-color: #fcffc4; color: black';
      }
      sh.highlight = sh.style; // not highlighted yet
      sh.selectBox = '';
      sh.isActive = false;
      sh.date = utl.upkDate(sh.dte);
      sh.time = utl.upkTime(sh.tme);
      // utl.diag(sh.dateSortKey);
      if (sh.time === '12:00 AM') {
        if (sh.date.substr(6, 4) < '2014') {
          sh.time = '';
        }
      }
      sh.date2 = `${sh.date}<br />${sh.time}`;
      sh.date3 = `${sh.date} ${sh.time}`; // For Printing
      sh.$amt = utl.fmtDollar(sh.amt);
      sh.sortAmount = utl.keyAmount(sh.amt);
      // utl.diag(`Tran Amount: ${sh.amt} -> ${sh.$amt}`);
      if (sh.amt >= 0) {
        sh.$cr = sh.$amt;
      } else {
        sh.$db = sh.$amt;
      }
      sh.$bal = utl.fmtDollar(sh.bal);
      sh.$amtBal = `${sh.$amt}<br />${sh.$bal}`;
      if (sh.code > state.trHigh) { // [154] If greater than known getTR(), get from HBSERV
        sh.desc = this.state.trDesc[sh.code];
      } else {
        sh.desc = getTR(sh.code);
      }
      if ((sh.card >= 10000) && (sh.card <= 19999)) { // [104] Last 4 digits of card #
        const card4 = sh.card.toString().substr(1, 4);
        sh.desc = `${sh.desc.trim()} - Card ${card4}`;
        sh.hasCard = true;
        sh.card4 = card4;
      } else {
        sh.hasCard = false;
        sh.card4 = 0;
      }
      sh.imgFront = '';
      sh.front = false;
      sh.imgBack = '';
      sh.back = false;
      sh.htmlMessage = '';
      sh.html = false;
      sh.descX = sh.desc;
      sh.desc2 = sh.desc;
      sh.isActive = false;
      sh.haveDetail = false;
      if (sh.atm > 0) {
        sh.atmDesc = this.state.atmDesc[sh.atm];
        sh.descX = sh.atmDesc;
        if (sh.dft > 0) {
          sh.desc2 = `${sh.desc} Draft#: ${sh.dft}<br />${sh.atmDesc}`;
        } else {
          sh.desc2 = `${sh.desc}<br />${sh.atmDesc}`;
        }
      } else {
        sh.atmDesc = '';
      }
      // sh.sortDescKey = `${sh.desc.toLowerCase()}${sh.atmDesc.toLowerCase()}`;
      sh.sortDescKey = `${sh.atmDesc.toLowerCase()}${sh.desc.toLowerCase()}`;
      if (sh.dft > 0) {
        state.histShares.draftCount += 1;
        sh.sortDraftKey = `${utl.padSpaces(sh.dft, 6)}${sh.sortDesc}`;
        if (sh.atm === 0) {
          sh.desc2 = `${sh.desc}<br />Draft Number: ${sh.dft}`;
        }
        sh.showDraftButton = false;
        sh.explain = true;
        sh.explainMessage = 'No image available for Drafts that clear via ACH.';
        if (sh.code === 31) {
          sh.showDraftButton = true; // Only show for "Share (Paid Draft)" items
          sh.explain = false;
        }
        if (state.validCU.dftImg !== 'Y') { // CU Not on Draft Image Program
          sh.showDraftButton = false;
          sh.explain = false;
        }
        if (state.history.share === 'P') {
          sh.share = 'P';
          sh.draftAcct = `${utl.padZero(state.mBase.pAcct, 9)}${state.mBase.pDgt}`;
          sh.chkAct = state.mBase.pAcct;
          sh.chkDgt = state.mBase.pDgt;
        } else {
          sh.share = 'D';
          sh.draftAcct = `${utl.padZero(state.mBase.dAcct, 9)}${state.mBase.dDgt}`;
          sh.chkAct = state.mBase.dAcct;
          sh.chkDgt = state.mBase.dDgt;
        }
      } else {
        sh.showDraftButton = false;
        sh.draftAcct = '';
        sh.sortDraftKey = `ZZZZZZ${sh.sortDesc}`; // Sort to end of list
      }
      sh.key = state.histShares.count;
      sh.item = state.histShares.count;
      sh.imgBox = `imgBox${state.histShares.count}`;
      sh.printHeader = `${sh.date} ${sh.time} ${sh.desc}# ${sh.dft} ${sh.$amt}`;
      state.histShares.arr[state.histShares.count] = sh;
      state.histShares.count += 1;
      // this.commit('storeDiag', `Share: ${sh.acct}-${sh.type} Desc: ${sh.desc}`);
    },
    extractHistLoan(state, plData) {
      const ln = plData.plHistLoan.decode(plData.subPacket);
      ln.dateSortKey = `${utl.padZero(ln.file, 5)}${utl.padZero(ln.tran, 5)}`;
      if (state.histLoans.count % 2) {
        ln.style = 'background-color: #ccffff; color: black';
      } else {
        ln.style = 'background-color: #fcffc4; color: black';
      }
      ln.highlight = ln.style; // not highlighted yet
      ln.selectBox = '';
      ln.type = 'L';
      ln.isActive = false;
      ln.date = utl.upkDate(ln.dte);
      ln.time = utl.upkTime(ln.tme);
      if (ln.time === '12:00 AM') {
        if (ln.date.substr(6, 4) < '2014') {
          ln.time = '';
        }
      }

      ln.date2 = `${ln.date}<br />${ln.time}`;
      ln.$amt = utl.fmtDollar(ln.amt);
      ln.sortAmount = utl.keyAmount(ln.amt);
      ln.$fc = utl.fmtDollar(ln.fc);
      ln.$pri = utl.fmtDollar(ln.pri);
      ln.$bal = utl.fmtDollar(ln.bal);
      ln.$amtBal = `${ln.$amt}<br />${ln.$bal}`;
      if (ln.code > state.trHigh) {
        ln.desc = this.state.trDesc[ln.code];
      } else {
        ln.desc = getTR(ln.code);
      }
      ln.descX = ln.desc;
      ln.isActive = false;
      ln.haveDetail = false;

      if (ln.atm > 0) {
        ln.atmDesc = this.state.atmDesc[ln.atm];
        ln.descX = `${ln.desc}<br />${ln.atmDesc}`;
      } else {
        ln.atmDesc = '';
      }
      ln.desc2 = `${ln.desc}<br />Int: ${ln.$fc} Pri: ${ln.$pri}`;
      ln.sortDescKey = `${ln.atmDesc.toLowerCase()}${ln.desc.toLowerCase()}`;

      if (ln.code === 104) { // Special for Delinquent Status
        ln.$amt = '';
        ln.$fc = '';
        ln.$pri = '';
        ln.$amtBal = ` <br />${ln.$bal}`;
        ln.descX = `${ln.desc}<br />${ln.atmDesc}`;
        ln.desc2 = `${ln.desc}<br />${ln.atmDesc}`;
      }

      ln.key = state.histLoans.count;
      state.histLoans.arr[state.histLoans.count] = ln;
      state.histLoans.count += 1;
    },
    extractHistDesc(state, plData) { // [154] Get this working
      const tr = plData.plHistDesc.decode(plData.subPacket);
      // code: 'uint16',
      // desc: 'char[40]',
      if (tr.code > 0) {
        this.state.trDesc[tr.code] = tr.desc;
        // utl.diag(`T ${tr.code} ${tr.desc}`);
      }
    },
    extractHistATM(state, plData) {
      const atm = plData.plHistATM.decode(plData.subPacket);
      // code: 'uint16',
      // desc: 'char[48]',
      if (atm.code > 0) {
        this.state.atmDesc[atm.code] = atm.desc;
        // utl.diag(`A ${atm.code} ${atm.desc}`);
      }
    },
    extractHistURL(state, plData) {
      // NOTE:  Extended FILE history is handled by jsProxy and sent to this
      //        client as if it came via the normal method.
      //        jsProxy pulls the file from the server, not this client
      //        This packet is informational only and only arrives if uploaded file not found
      //        See jsProxy: getHistFile()
      const url = plData.plHistURL.decode(plData.subPacket);
      this.state.urlFname = url.fname;
      this.state.urlMD5 = url.md5sum;
      this.state.urlFsize = url.fsize;
      // utl.diag(`urlFname='${state.urlFname}`);
      // utl.diag(`urlMD5='${state.urlMD5}`);
      // utl.diag(`urlFsize='${state.urlFsize}`);
    },
    extractHistPend(state, plData) { // [153]
      const pp = plData.plHistPend.decode(plData.subPacket);
      if (state.histPend.count % 2) {
        pp.style = 'background-color: #ccffff; color: black';
      } else {
        pp.style = 'background-color: #fcffc4; color: black';
      }
      pp.highlight = pp.style; // not highlighted yet
      pp.selectBox = '';
      pp.isActive = false;
      pp.date = utl.upkDate(pp.dte);
      pp.time = utl.upkTime(pp.tme);
      if (pp.time === '12:00 AM') {
        if (pp.date.substr(6, 4) < '2014') {
          pp.time = '';
        }
      }
      pp.remain = `${utl.padSpaces(pp.remainHR, 2)}hr ${utl.padSpaces(pp.remainMI, 2)}mi`;
      pp.date2 = `${pp.date}<br />${pp.time}`;
      pp.date3 = `${pp.date} ${pp.time}`; // For Printing
      pp.$amt = utl.fmtDollar(pp.amt);
      if (pp.amt >= 0) {
        pp.$cr = pp.$amt;
      } else {
        pp.$db = pp.$amt;
      }
      pp.$bal = utl.fmtDollar(pp.bal);

      if (pp.card > 9999) {
        pp.cardx = `Card: ${utl.padZero(pp.card - 10000, 4)}`;
      }
      pp.trDesc = '';
      pp.atmDesc = '';
      if (pp.code > 0) {
        pp.desc = this.state.trDesc[pp.code];
        pp.desc2 = pp.desc;
      }
      if (pp.atm > 0) {
        pp.atmDesc = this.state.atmDesc[pp.atm];
        pp.desc2 = `${pp.desc}<br />${pp.atmDesc}`;
      }
      if (pp.pendType === 'T') {
        // pp.$amtBal = `${pp.$amt}<br />${pp.$bal}`; // Total has Amt and Bal
        pp.$amtBal = pp.$amt; // Total has Amt and Bal
        pp.desc2 = 'Total Amount Pending:<br />Anticipated Balance:';
        pp.date2 = 'Total-Pend';
        pp.date3 = 'Total-Pend'; // For Printing
        pp.remain = `Available<br />${pp.$bal}`;
      } else {
        pp.$amtBal = `${pp.$amt}<br />${pp.cardx}`; // Individual pends don't have a BAL
      }

      pp.key = state.histPend.count;

      state.histPend.arr[state.histPend.count] = pp;
      state.histPend.count += 1;

      /*
      const idx = state.histPend.count;
      utl.diag(`Pend: ${idx} ${pp.pendType} ${pp.remain} ${pp.$amt} ${pp.code} ->${pp.trDesc}
              ${pp.atm} -> ${pp.atmDesc} ${pp.cardx}
              ${pp.$bal}`);
      */
    },
    /* SHARE sort order
      0 = reverse date order - newest first
      1 = forward date order - oldest first
      2 = Description order forward
      3 = Description order reverse
      4 = Draft # Description order
      5 = Withdrawal Order (highest negative amount first - highest positive last)
      6 = Deposit Order (highest positive amount first - highest negative amount last)
     */

    sortShareDate() {
      // sh.dateSortKey
      // utl.diag('sortShareDate');
      if (this.state.histShares.sortOrder === 0) {
        this.state.histShares.arr.sort((a, b) => (a.dateSortKey - b.dateSortKey));
        this.state.histShares.sortOrder = 1;
      } else {
        this.state.histShares.arr.sort((a, b) => (b.dateSortKey - a.dateSortKey));
        this.state.histShares.sortOrder = 0;
      }
      this.commit('syncShareList');
      this.state.histShares.changeCount += 1; // Force Screen Update
    },
    sortShareDesc() {
      let doSort = 0;
      if ((this.state.histShares.sortOrder < 2) || (this.state.histShares.sortOrder > 4)) {
        doSort = 2; // Sort by Description - Forward
      }
      if (this.state.histShares.sortOrder === 2) { // Current = Desc-Forward
        doSort = 3; // Sort by Description - Reverse
      }
      if (this.state.histShares.sortOrder === 3) { // Current = Desc-Reverse
        doSort = 4; // Sort by Draft (forward)
      }
      if (this.state.histShares.sortOrder === 4) { // Current = Draft
        doSort = 2; // Sort by Description - Forward
      }
      if ((doSort === 4) && (this.state.histShares.draftCount === 0)) doSort = 2; // No drafts
      if (doSort === 2) { // Sort Description Forward
        this.state.histShares.arr.sort((a, b) => (utl.compareDesc(a, b)));
      }
      if (doSort === 3) { // Sort Description Reverse
        this.state.histShares.arr.sort((a, b) => (utl.compareDesc(b, a)));
      }
      if (doSort === 4) { // Sort Draft # Forward
        this.state.histShares.arr.sort((a, b) => (utl.compareDraft(a, b)));
      }
      this.state.histShares.sortOrder = doSort;
      this.commit('syncShareList');
      this.state.histShares.changeCount += 1; // Force Screen Update
    },
    sortShareWth() {
      // (prev, current) => (prev.id > current.id ? prev.id : current.id)
      // utl.diag('sortShareWth');
      // eslint-disable-next-line
      if (this.state.histShares.sortOrder !== 5) {
        // this.state.histShares.arr.sort((a, b) => (a.sortAmount < b.sortAmount ? 1 : -1));
        this.state.histShares.arr.sort((a, b) => (a.sortAmount - b.sortAmount));
        this.state.histShares.sortOrder = 5;
      } else {
        // this.state.histShares.arr.sort((a, b) => (a.sortAmount > b.sortAmount ? 1 : -1));
        this.state.histShares.arr.sort((a, b) => (b.sortAmount - a.sortAmount));
        this.state.histShares.sortOrder = 6;
      }
      this.commit('syncShareList');
      this.state.histShares.changeCount += 1; // Force Screen Update
    },
    sortShareDep() {
      // utl.diag('sortShareDep');
      // eslint-disable-next-line
      if (this.state.histShares.sortOrder !== 6) {
        this.state.histShares.arr.sort((a, b) => (b.sortAmount - a.sortAmount));
        this.state.histShares.sortOrder = 6;
      } else {
        this.state.histShares.arr.sort((a, b) => (a.sortAmount - b.sortAmount));
        this.state.histShares.sortOrder = 5;
      }
      this.commit('syncShareList');
      this.state.histShares.changeCount += 1; // Force Screen Update
    },
    syncShareList() {
      // utl.diag('syncShareList');
      for (let i = 0; i < this.state.histShares.count; i += 1) {
        const sh = this.state.histShares.arr[i];
        if (i % 2) {
          sh.style = 'background-color: #ccffff; color: black';
        } else {
          sh.style = 'background-color: #fcffc4; color: black';
        }
        sh.highlight = this.state.histShares.arr[i].style;
        sh.selectBox = '';
        sh.isActive = false;
        sh.key = i;
        sh.item = i;
        sh.imgBox = `imgBox${i}`;
        if (this.state.histShares.sortOrder < 2) {
          sh.$bal = utl.fmtDollar(sh.bal);
          sh.$amtBal = `${sh.$amt}<br />${sh.$bal}`;
        } else {
          sh.$bal = ''; // Balance doesn't make any sense for sorted transactions
          sh.$amtBal = `${sh.$amt}<br />${sh.$bal}`;
        }
      }
      this.state.histShares.dateHeader = 'Date';
      if (this.state.histShares.sortOrder === 0) {
        this.state.histShares.dateHeader = 'Date-Rev';
      }
      if (this.state.histShares.sortOrder === 1) {
        this.state.histShares.dateHeader = 'Date-Fwd';
      }
      //
      this.state.histShares.descHeader = 'Description';
      if (this.state.histShares.sortOrder === 2) {
        this.state.histShares.descHeader = 'Description-Fwd';
      }
      if (this.state.histShares.sortOrder === 3) {
        this.state.histShares.descHeader = 'Description-Rev';
      }
      if (this.state.histShares.sortOrder === 4) {
        this.state.histShares.descHeader = 'Description-Dft';
      }
    },

    /* LOAN sort order
    0 = reverse date order - newest first
    1 = forward date order - oldest first
    2 = Description order forward
    3 = Description order reverse
    5 = Payment Order (highest negative amount first - highest positive last)
    6 = Payment Order (highest positive amount first - highest negative amount last)
   */
    sortLoanDate() {
      if (this.state.histLoans.sortOrder === 0) {
        this.state.histLoans.arr.sort((a, b) => (a.dateSortKey - b.dateSortKey));
        this.state.histLoans.sortOrder = 1;
      } else {
        this.state.histLoans.arr.sort((a, b) => (b.dateSortKey - a.dateSortKey));
        this.state.histLoans.sortOrder = 0;
      }
      this.commit('syncLoanList');
      this.state.histLoans.changeCount += 1; // Force Screen Update
    },
    sortLoanDesc() {
      let doSort = 0;
      if ((this.state.histLoans.sortOrder < 2) || (this.state.histLoans.sortOrder > 3)) {
        doSort = 2; // Sort by Description - Forward
      }
      if (this.state.histLoans.sortOrder === 2) { // Current = Desc-Forward
        doSort = 3; // Sort by Description - Reverse
      }
      if (this.state.histLoans.sortOrder === 3) { // Current = Desc-Reverse
        doSort = 2; // Sort by Description - Forward
      }
      if (doSort === 2) { // Sort Description Forward
        this.state.histLoans.arr.sort((a, b) => (utl.compareDesc(a, b)));
      }
      if (doSort === 3) { // Sort Description Reverse
        this.state.histLoans.arr.sort((a, b) => (utl.compareDesc(b, a)));
      }
      this.state.histLoans.sortOrder = doSort;
      this.commit('syncLoanList');
      this.state.histLoans.changeCount += 1; // Force Screen Update
    },
    sortLoanPay() {
      if (this.state.histLoans.sortOrder !== 5) {
        this.state.histLoans.arr.sort((a, b) => (a.sortAmount - b.sortAmount));
        this.state.histLoans.sortOrder = 5;
      } else {
        this.state.histLoans.arr.sort((a, b) => (b.sortAmount - a.sortAmount));
        this.state.histLoans.sortOrder = 6;
      }
      this.commit('syncLoanList');
      this.state.histLoans.changeCount += 1; // Force Screen Update
    },

    syncLoanList() {
      // utl.diag('syncShareList');
      for (let i = 0; i < this.state.histLoans.count; i += 1) {
        const ln = this.state.histLoans.arr[i];
        if (i % 2) {
          ln.style = 'background-color: #ccffff; color: black';
        } else {
          ln.style = 'background-color: #fcffc4; color: black';
        }
        ln.highlight = this.state.histLoans.arr[i].style;
        ln.selectBox = '';
        ln.isActive = false;
        ln.key = i;
        ln.item = i;
        ln.imgBox = `imgBox${i}`;
        if (this.state.histLoans.sortOrder < 2) {
          ln.$bal = utl.fmtDollar(ln.bal);
          ln.$amtBal = `${ln.$amt}<br />${ln.$bal}`;
        } else {
          ln.$bal = ''; // Balance doesn't make any sense for sorted transactions
          ln.$amtBal = `${ln.$amt}<br />${ln.$bal}`;
        }
      }
      this.state.histLoans.dateHeader = 'Date';
      if (this.state.histLoans.sortOrder === 0) {
        this.state.histLoans.dateHeader = 'Date-Rev';
      }
      if (this.state.histLoans.sortOrder === 1) {
        this.state.histLoans.dateHeader = 'Date-Fwd';
      }
      //
      this.state.histLoans.descHeader = 'Description';
      if (this.state.histLoans.sortOrder === 2) {
        this.state.histLoans.descHeader = 'Description-Fwd';
      }
      if (this.state.histLoans.sortOrder === 3) {
        this.state.histLoans.descHeader = 'Description-Rev';
      }
    },

    //------------------------------------------------------------------
    //------------------------------------------------------------------
    handleC4GetMyCuName(state, ar) {
      state.bpBPV = parseInt(ar.base.cuBPV, 10);
      state.cuVal = parseInt(ar.base.cuVal, 10); // [174]
      // utl.diag(`cuVal=${state.cuVal}`);
      // special for ONE MEMBER at Dubois
      if (this.state.cun === 20805) {
        state.bpBPV = 1;
      }
      if (this.state.cun === '20805') {
        state.bpBPV = 1;
      }

      // utl.diag(ar);
      if (ar.status === 0) { // [175] This section added
        const t1 = 'This APP is unavailable';
        const l1 = 'Please contact your Credit Union<br />';
        const l2 = 'with any questions about your account<br />';
        const l3 = 'or information about their current HomeBank app';
        // Link: ${this.state.fullURL}
        utl.popWarning(this.commit, t1, `<div>${l1}${l2}${l3}</div>`);
        return;
      }

      state.validCU.enroll = ar.base.cuFlash; // [135] Get this during c4GetMyCuName
      state.validCU.dftImg = ar.base.dftImg; // [135] Get this during c4GetMyCuName
      if (state.validCU.enroll === 'e') { // [160]
        state.validCU.enroll = 'E'; // [160]
        // utl.diag('handleC4GetMyCuName - cuFlash = "e"');
      }
      this.state.cuName = ar.base.cuName;
      utl.setAppName(this.commit, this.state, this.state.appName);
      if ((ar.status === 0) || (ar.status > 10)) {
        this.state.alert.message = 'Credit Union is Offline';
        this.state.alert.show = true;
      } else {
        utl.setCuName(this.commit, this.state, this.state.cun, this.state.cuName);
        if (this.state.cun > 12999) { // Ignore for 10101 (init)
          this.commit('requestSavedAccounts');
        }
      }
      if (typeof ar.verMsgPresent !== 'undefined') {
        try {
          if (ar.verMsgPresent === true) {
            state.pmTitle = 'Message From Server';
            state.pmMessage = ar.versionMessage; // [142]
            state.pmShow = true; // [142]
          }
        } catch (e) {
          //
        }
      }
    },
    handleC4GetDraftImage(state, ar) {
      // utl.diag(ar);
      if (ar.status === 0) {
        state.histShares.arr[ar.shItem].imgFront = ar.urlFront;
        state.histShares.arr[ar.shItem].imgBack = ar.urlBack;
        state.histShares.arr[ar.shItem].front = true;
        state.histShares.arr[ar.shItem].back = true;
        state.histShares.arr[ar.shItem].html = false;
      }
      if (ar.status === 9) {
        state.histShares.arr[ar.shItem].htmlMessage = ar.htmlMessage;
        state.histShares.arr[ar.shItem].front = false;
        state.histShares.arr[ar.shItem].back = false;
        state.histShares.arr[ar.shItem].html = true;
      }
      state.histShares.arr[ar.shItem].explain = false;
      state.histShares.changeCount += 1; // Force Update
    },
    handleC4RequestPin(state, ar) {
      const rsp = ar.rsp;
      state.confirm.show = false;
      state.alert.show = false;
      let rErr = ar.rErr;

      utl.diag('-------------------------------------------');
      utl.diag('Response from c4RequestPin');
      utl.diag(ar);
      // utl.diag(rsp);
      if (ar.rsp.error > 0) rErr = ar.rsp.error;

      if (rErr === 0) {
        state.enablePinOK = true;
        const fm = utl.fmtPhone(ar.fmPhone);
        const to = utl.fmtPhone(ar.toPhone);
        if (ar.rOpt === 1) {
          this.commit('setConfirmMessage',
            `Pin via SMS from ${fm} to ${to}`);
        }
        if (ar.rOpt === 2) {
          this.commit('setConfirmMessage',
            `Pin via Voice from ${fm} to ${to}`);
        }
        if (ar.rOpt === 11) {
          this.commit('setConfirmMessage',
            `Pin via SMS from ${fm} to ${to}`);
        }
        if (ar.rOpt === 12) {
          this.commit('setAlertMessage',
            'International VOICE Pin not currently supported');
        }
      } else {
        state.enablePinOK = false;
        if (rErr === 1) {
          this.commit('setAlertMessage', 'Phone # not defined as mobile - Try voice call');
        }
        if (rErr === 2) {
          // const t1 = 'Validation Error';
          const t1 = `Phone # Not on Account ${rsp.acct}`;
          const d1 = '<div style="font-size: 16px;">';
          // const l1 = `Phone # is not valid for account ${rsp.acct}.<br />`;
          const l2 = '<b style="color:red;">Please verify the following information</b><br />';
          const l3 = `Account Number: ${rsp.acct}<br />`;
          const l4 = `Phone # on acct: ${state.vPhone}<br />`;
          const l5 = `Credit Union: ${state.cuName}<br />`;
          const l6 = '<b style="color:red;">If the CU name is wrong, click on the<br />';
          const l7 = 'CU name at the top of the Sign-in page.</b>';
          utl.popWarning(this.commit, t1, `${d1}${l2}${l3}${l4}${l5}${l6}${l7}</div>`);
        }
        if (rErr === 101) {
          this.commit('setAlertMessage', 'Credit Union is offline - Please try later');
        }
      }
      // utl.diag('-------------------------------------------');
    },
    handleC4ValidatePin(state, ar) {
      const rsp = ar.rsp;
      state.confirm.show = false;
      state.alert.show = false;

      // utl.diag(ar);

      // utl.diag('Response from c4ValidatePin');
      // utl.diag(ar);
      // utl.diag(rsp);
      if (ar.rErr === 0) {
        this.commit('storeDiag', `Set Token: ${this.state.pkAct} -> ${ar.hexToken}`);
        if (state.otp === false) {
          this.commit('storeDiag', 'One-Time-Use = FALSE - Store Permanent Device Token');
          utl.setAcctToken(this.commit, state, this.state.pkAct, ar.hexToken);
        } else {
          this.commit('storeDiag', 'One-Time-Use = TRUE - Do NOT Store Device Token');
          state.otKeyK = this.state.pkAct; // [191] Key
          state.otKeyV = ar.hexToken; // [191] Set temp KeyValue
          this.commit('storeDiag', `otKeyK="${state.otKeyK}"`);
          this.commit('storeDiag', `otKeyV="${state.otKeyV}"`);
        }
        state.returnFromMFA = true;
        state.accountMFA = rsp.acct;
        state.doEnroll = false; // [093]
        window.history.back(); // go back from MFA page to Sign-In page
        if (ar.enrollStat === 0) { // [093] Account not enrolled yet
          state.doEnroll = true; // [093] Go to enroll page
        } else {
          this.commit('setConfirmMessage', 'Pin successfully Validated');
        }
      } else {
        this.commit('setAlertMessage', 'Incorrect or Expired Pin');
      }
      // utl.diag('-------------------------------------------');
    },
    handleC4SecurityImage(state, myObject) {
      const rsp = myObject.rsp;
      // [137] state.validCU = myObject.validCU;

      // utl.diag('Response from c4GetSecurityImage!');
      // utl.diag(myObject);
      // utl.diag(rsp);
      // utl.diag(myObject.validCU);
      // utl.diag('-------------------------------------------');
      // eslint-disable-next-line
      const plTest = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
      });

      const imgMap = $spk.build({
        size: 'uint8', // 64
        ident: 'char[1]', // "B"
        f1: 'uint16', // Not used
        status: 'uint8', // Account Status
        cat: 'uint8', // Image Category
        num: 'uint8', // Image Number
        valid: 'uint8', // Is valid
        caption: 'char[30]', // Member Custom Caption for Image
        f2: 'uint16', // Not used
        enrollStat: 'uint8', // Enrollment Status
        fillx: 'char[23]', // Not used
      });

      // eslint-disable-next-line
      const clMap = $spk.build({
        size: 'uint8', // 128
        ident: 'char[1]', // "C"
        lType: 'char[1]', // Link Type (W/S/E)
        slot: 'uint8', // Slot the CU put this in (in 68-G)
        caption: 'char[18]', // Button Caption
        linkURL: 'char[100]', // Link to URL
        fillx: 'char[6]', // Not used
      });

      const myTrHigh = getTR(0);
      this.state.trHigh = myTrHigh.substr(0, 3);
      // if (this.state.cun === 22000) { this.state.trHigh = '360'; }
      this.commit('storeDiag', `getTR(0): ${myTrHigh} trHigh=${this.state.trHigh}`);

      if (myObject.plSize > 0) {
        this.commit('storeDiag', `7708 - Extract Payload - plSize=${myObject.plSize}`);
        const payload = utl.extractPayload(myObject);
        let ptr = 0;
        const plData = {};
        plData.imgMap = imgMap;
        plData.clMap = clMap;
        //
        // Blank out Custom Links in case they delete one
        for (let i = 0; i < 9; i += 1) {
          if (typeof this.state.customLinks[i] !== 'undefined') {
            this.state.customLinks[i].valid = false;
          }
        }

        let itemCount = 0;
        while (ptr < myObject.plSize) {
          const pl = plTest.decode(payload.slice(ptr, ptr + 2));
          plData.subPacket = payload.slice(ptr, ptr + pl.size);
          // this.commit('storeDiag', `ptr: ${ptr} Size: ${pl.size} Ident: ${pl.ident}`);
          if (pl.ident === 'B') this.commit('extractSecurityImage', plData);
          if (pl.ident === 'C') this.commit('extractSecurityLinks', plData);
          ptr += pl.size;
          itemCount += 1;
          if (itemCount > 40) { // Just in case
            utl.diag('7708 - Too Many Items - Aborting');
            break;
          }
        }
      } else {
        // msg = `No Payload to Extract - plSize=${myObject.plSize}`;
        // this.commit('storeDiag', msg);
      }

      // Received SecurityImage packet - Initialize c4GetBanners
      const cuInfo = {};
      cuInfo.cun = rsp.cun;
      cuInfo.acct = rsp.acct;
      cuInfo.location = state.location;
      cuInfo.rpcName = 'c4GetBanners';
      try {
        state.socket.ws.send(JSON.stringify(cuInfo));
      } catch (e) {
        // utl.diag(e); // Should never fail since just got request for SecurityImage via socket
      }
    },
    extractSecurityImage(state, plData) {
      // this.commit('storeDiag', 'Extract 7708 Security Image');
      const img = plData.imgMap.decode(plData.subPacket);
      if (img.enrollStat === 0) {
        this.commit('setPageIndex', 15); // Show Enroll Page
      } else {
        this.commit('setShowFooter', true);
        if ((img.cat > 0) && (img.num > 0)) {
          const base = this.state.seImg.imgBase;
          const cat = utl.padZero(img.cat, 3);
          const num = utl.padZero(img.num, 3);
          this.state.seImg.imgSource = `${base}${cat}/${num}.jpg`;
          this.state.seImg.imgCaption = img.caption;
          // this.state.seImg.imgValid = img.valid;
          this.state.seImg.imgValid = (img.valid === 1);
          // utl.diag(this.state.seImg);
          this.commit('storeDiag', `seImgSource: ${this.state.seImg.imgSource}`);
        } else {
          this.state.seImg.imgValid = false;
          this.commit('storeDiag', 'Account does not have a Security Image');
        }
      }
    },
    extractSecurityLinks(state, plData) {
      // this.commit('storeDiag', 'Extract 7708 Custom Links');
      const link = plData.clMap.decode(plData.subPacket);
      // utl.diag(link);
      const idx = link.slot;
      let pre = 'http://';
      if (link.lType === 'S') { pre = 'https://'; }
      if (link.lType === 'E') { pre = 'email://'; }
      this.state.customLinks[idx] = {};
      this.state.customLinks[idx].valid = true;
      this.state.customLinks[idx].caption = link.caption.trim();
      this.state.customLinks[idx].linkURL = `${pre}${link.linkURL.trim()}`;
      // utl.diag(this.state.customLinks[idx]);
    },

    async handleC4SignIn(state, myObject) {
      const rsp = myObject.rsp;
      // eslint-disable-next-line
      // console.log(rsp);

      // this.commit('storeDiag', `handleC4SignIn - rsp.error=${rsp.error}`);
      // this.commit('storeDiag', `handleC4SignIn - rsp.sesh=${rsp.sesh}`);
      // this.commit('storeDiag', `handleC4SignIn - rsp.subt=${rsp.subt}`);
      if (rsp.subt > 0) {
        // this.commit('storeDiag', `acctKey = ${myObject.acctKey}`);
        // this.commit('storeDiag', `encUser = ${myObject.encUser}`);
        // this.commit('storeDiag', `encPass = ${myObject.encPass}`);
        if (!utl.checkInPersist(this.commit, this.state, myObject.acctKey.substr(0, 8))) {
          state.saveUpdated = true; // Saving it NEW - Need to request saved accounts after signOff
        } else {
          state.saveUpdated = false; // Already in savedAccount array, so no need to request it
        }
        await utl.removeDuplicateAcct(this.commit, this.state, myObject.acctKey.substr(0, 8));
        await utl.setPersist(this.commit, this.state, `a1-${myObject.acctKey}`, myObject.encUser);
        if (rsp.subt === 2) {
          await utl.setPersist(this.commit, this.state, `a2-${myObject.acctKey}`, myObject.encPass);
        }
      }
      state.hasDraft = false; // [178]
      state.seshID = rsp.sesh;
      state.shares.count = 0;
      state.shares.sar = [];
      state.shares.header = 'Shares';
      state.shares.changeCount = 0;
      state.shares.total = 0;
      state.loans.count = 0;
      state.loans.lar = [];
      state.loans.header = 'Loans';
      state.loans.changeCount = 0;
      state.loans.total = 0;

      if (rsp.error > 0) {
        this.state.alert.error = rsp.error;
        this.state.alert.message = utl.getServerStatus(rsp.error);
        this.state.alert.show = true;
        if (rsp.error === 105) {
          this.state.alert.message = `${this.state.alert.message}: ${rsp.acct}`;
        }
        if (rsp.error === 112) {
          this.state.showUnlockOption = true;
        }
        return;
        // eslint-disable-next-line
      } else {
        this.state.alert.error = 0;
      }

      const plTest = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
      });
      // eslint-disable-next-line
      const plBase = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
        sarcnt: 'uint8',
        larcnt: 'uint8',
        crtcnt: 'uint8',
        auth: 'uint8',
        opts: 'uint16',
        dAcct: 'uint32',
        pAcct: 'uint32',
        dDgt: 'uint8',
        pDgt: 'uint8',
        sDate: 'uint16',
        name: 'char[32]',
        aba: 'uint32',
        fill: 'char[40]',
      });
      // eslint-disable-next-line
      const plShare = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
        type: 'char[1]',
        ira: 'uint8',
        acct: 'uint32',
        bal: 'int32',
        ytd: 'int32',
        plg: 'int32',
        desc: 'char[20]',
        ltd: 'uint16',
        xfFM: 'char[1]',
        xfTO: 'char[1]',
        rtPlg: 'uint16',
        fill: 'uint16',
      });
      // eslint-disable-next-line
      const plLoan = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
        type: 'uint8',
        freq: 'char[1]',
        acct: 'uint32',
        note: 'uint32',
        rPay: 'int32',
        dPay: 'int32',
        bal: 'int32',
        ytd: 'int32',
        dlq: 'int32',
        pOff: 'int32',
        limit: 'int32',
        apr: 'uint16',
        npdd: 'uint16',
        addOn: 'uint8',
        dlqFlg: 'uint8',
        chgOff: 'uint16',
        visa1: 'uint32',
        visa2: 'uint32',
        ahead: 'int32',
        closed: 'uint16',
        fill: 'char[2]',
      });
      // eslint-disable-next-line
      const plCert = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
        type: 'char[1]',
        toType: 'char[1]',
        toAcct: 'uint32',
        acct: 'uint32',
        term: 'uint16',
        apr: 'uint16',
        effRate: 'uint16',
        orgDate: 'uint16',
        orgBal: 'int32',
        matDiv: 'int32',
        matDate: 'uint16',
        number: 'char[6]',
        iraType: 'char[12]',
      });
      // eslint-disable-next-line
      /* const plUser = $spk.build({
        size: 'uint8',
        ident: 'char[1]',
        saveOpt: 'uint8',
        fill1: 'uint8',
        user: 'char[16]',
        pass: 'char[32]',
        filler: 'char[12]',
      }); */
      if (myObject.plSize > 0) {
        // this.commit('storeDiag', `Extract Payload - plSize=${myObject.plSize}`);
        state.member.acct = rsp.acct;
        const payload = utl.extractPayload(myObject);
        let ptr = 0;
        const plData = {};
        plData.plBase = plBase;
        plData.plShare = plShare;
        plData.plLoan = plLoan;
        plData.plCert = plCert;

        // plData.plUser = plUser;
        //
        let itemCount = 0;
        while (ptr < myObject.plSize) {
          const pl = plTest.decode(payload.slice(ptr, ptr + 2));
          plData.subPacket = payload.slice(ptr, ptr + pl.size);
          // this.commit('storeDiag', `ptr: ${ptr} Size: ${pl.size} Ident: ${pl.ident}`);
          if (pl.ident === 'B') this.commit('extractBase', plData);
          if (pl.ident === 'S') this.commit('extractShare', plData);
          if (pl.ident === 'L') this.commit('extractLoan', plData);
          if (pl.ident === 'C') this.commit('extractCert', plData);
          // if (pl.ident === 'U') this.commit('saveUser', plData);
          ptr += pl.size;
          itemCount += 1;
          if (itemCount > 128) { // Just in case
            utl.diag('Sign-in - Too Many Items - Aborting');
            break;
          }
        }
      } else {
        // msg = `No Payload to Extract - plSize=${myObject.plSize}`;
        // this.commit('storeDiag', msg);
      }

      this.commit('setSignedIn', true);
      this.commit('setPageIndex', 1);
      this.commit('setShowMenuButton', true);
      this.commit('setShowBanner', true);

      if (state.cuVal === 6) { // [174]
        if (typeof myObject.ex !== 'undefined') {
          const ex = myObject.ex;
          // utl.diag(ex);
          const t1 = `${ex.title}`;
          const l1 = `${ex.msg1}<br />`;
          const l2 = `${ex.msg2}<br />`;
          let l3 = '';
          let l4 = '';
          if (typeof ex.msg3 !== 'undefined') {
            l3 = `${ex.msg3}<br />`;
          }
          if (typeof ex.url !== 'undefined') {
            l4 = `<a href="${ex.url}">${ex.url}</a>`;
          }
          utl.popWarning(this.commit, t1, `${l1}${l2}${l3}${l4}`);
        }
      }

      /*
      // Save the user/pass - Send to c4Proxy to be encrypted
      const cuInfo = {};
      cuInfo.cun = rsp.cun;
      cuInfo.rpcName = 'c4SaveLoginInfo';
      cuInfo.userPass = this.state.userPass;
      this.commit('sendObjToServer', cuInfo);
      */
    },
    extractBase(state, plData) {
      const b = plData.plBase.decode(plData.subPacket);
      state.member.name = utl.toTitleCase(b.name);
      state.mBase = b;
      // utl.diag(`dAcct: ${state.mBase.dAcct}`);
      // utl.diag(`dDgt:  ${state.mBase.dDgt}`);
      // utl.diag(`pAcct: ${state.mBase.pAcct}`);
      // utl.diag(`pDgt:  ${state.mBase.pDgt}`);
      // utl.diag(`aba:   ${state.mBase.aba}`);
    },
    extractShare(state, plData) {
      const sh = plData.plShare.decode(plData.subPacket);
      sh.avail = (sh.bal - sh.plg);
      if (sh.type === 'D') state.hasDraft = true; // [178]
      if (sh.avail < 0) { sh.avail = 0; }
      if (state.shares.count % 2) {
        sh.style = 'background-color: #ccffff; color: black';
      } else {
        sh.style = 'background-color: #fcffc4; color: black';
      }
      sh.highlight = sh.style; // not highlighted yet
      sh.isCert = false;
      sh.isActive = false;
      sh.$avail = utl.fmtDollar(sh.avail);
      sh.$bal = utl.fmtDollar(sh.bal);
      sh.$ytd = utl.fmtDollar(sh.ytd);
      sh.$plg = utl.fmtDollar(sh.plg);
      sh.key = state.shares.count;
      state.shares.total += sh.bal; // [171]
      state.shares.sar[state.shares.count] = sh;
      state.shares.count += 1;
      if (state.shares.count > 1) {
        state.shares.header = `${state.shares.count} Shares - Total $${utl.fmtDollar(state.shares.total).trim()}`;
      } else {
        state.shares.header = `${state.shares.count} Share - Total $${utl.fmtDollar(state.shares.total).trim()}`;
      }
      // this.commit('storeDiag', `Share: ${sh.acct}-${sh.type} Desc: ${sh.desc}`);
    },
    extractLoan(state, plData) {
      const ln = plData.plLoan.decode(plData.subPacket);
      if (state.loans.count % 2) {
        ln.style = 'background-color: #ccffff; color: black';
      } else {
        ln.style = 'background-color: #fcffc4; color: black';
      }
      ln.highlight = ln.style; // not highlighted yet
      ln.type = 'L';
      ln.isActive = false;
      ln.$rPay = utl.fmtDollar(ln.rPay);
      ln.$dPay = utl.fmtDollar(ln.dPay);
      ln.$bal = utl.fmtDollar(ln.bal);
      ln.$dlq = utl.fmtDollar(ln.dlq);
      ln.$payoff = utl.fmtDollar(ln.pOff);
      ln.$ytd = utl.fmtDollar(ln.ytd);
      ln.APR = utl.fmtAPR(ln.apr);
      ln.NPDD = utl.upkDate(ln.npdd);
      ln.FREQ = this.state.freqs[ln.freq];
      const perDiem = Math.round((ln.bal * ln.apr) / 365000);
      ln.perDiem = utl.fmtDiem(perDiem);
      if (ln.chgOff > 0) {
        ln.coDate = utl.upkDate(ln.chgOff);
      } else {
        ln.coDate = 'N/A';
      }
      ln.openStatus = 'Open';
      if (ln.closed > 0) ln.openStatus = 'Closed';
      if (ln.coDate > 0) ln.openStatus = 'Charged Off';

      if (ln.openStatus === 'Open') { // [171]
        state.loans.total += ln.bal; // [171]
      }

      if (ln.limit > 0) {
        let avail = (ln.limit - ln.bal);
        if (avail < 0) avail = 0;
        ln.$limit = utl.fmtDollar(ln.limit);
        ln.$avail = utl.fmtDollar(avail);
      } else {
        ln.$limit = 'N/A';
        ln.$avail = 'N/A';
      }

      ln.key = state.loans.count;
      state.loans.lar[state.loans.count] = ln;
      state.loans.count += 1;
      if (state.loans.count > 1) {
        state.loans.header = `${state.loans.count} Loans - Total $${utl.fmtDollar(state.loans.total).trim()}`;
      } else {
        state.loans.header = `${state.loans.count} Loan - Total $${utl.fmtDollar(state.loans.total).trim()}`;
      }
    },
    extractCert(state, plData) {
      const ct = plData.plCert.decode(plData.subPacket);
      let ss = 0;
      for (let i = 0; i < state.shares.count; i += 1) {
        if (this.state.shares.sar[i].type === ct.type) {
          ss = i;
          state.shares.sar[i].toType = ct.toType;
          state.shares.sar[i].toAcct = ct.toAcct;
          state.shares.sar[i].destAcct = `${ct.toAcct}-${ct.toType}`;
          state.shares.sar[i].term = ct.term;
          state.shares.sar[i].apr = utl.fmtAPR(ct.apr);
          state.shares.sar[i].effRate = utl.fmtAPR(ct.effRate);
          state.shares.sar[i].orgDate = utl.upkDate(ct.orgDate);
          state.shares.sar[i].$orgBal = utl.fmtDollar(ct.orgBal);
          state.shares.sar[i].$matDiv = utl.fmtDollar(ct.matDiv);
          state.shares.sar[i].matDate = utl.upkDate(ct.matDate);
          state.shares.sar[i].number = ct.number;
          state.shares.sar[i].iraType = ct.iraType;
          state.shares.sar[i].isCert = true;
          break;
        }
      }
      if (ss === 0) {
        this.commit('storeDiag', `NO MATCH found for Cert Type: ${ct.type}`);
      }
    },
    saveUser(state, plData) {
      const usr = plData.plUser.decode(plData.subPacket);
      this.commit('storeDiag', `plUser.size=${usr.size}`);
      this.commit('storeDiag', `plUser.ident=${usr.ident}`);
      this.commit('storeDiag', `plUser.saveOpt=${usr.saveOpt}`);
      this.commit('storeDiag', `plUser.user=${usr.user}`);
      this.commit('storeDiag', `plUser.pass=${usr.pass}`);
      //
    },
    handleGotMessage(state, plData) {
      // Not used yet - Returning Upgrade message in c4GetMyCuName packet
      utl.diag(`handleGotMessage: '${plData.message}'`);
    },
    handleC4ExportReady(state, plData) {
      // utl.diag(plData);
      // state.exportInfo.sourceURL = `https://${state.baseURL}/${plData.exportSub}/${plData.exportBaseName}`;
      state.exportInfo.sourceURL = `${plData.exportURL}${plData.exportSub}/${plData.exportBaseName}`;
      state.exportInfo.destinFile = plData.exportAcctName;
      state.exTitle = 'Download Export File';
      state.exMessage = `Export file is ready to download<br>
            Filename: ${state.exportInfo.destinFile}`;
      state.exShow = true;
    },
    //------------------------------------------------------------------
    //------------------------------------------------------------------
  },
  actions: {
    initApp() {
      this.commit('startInit');
    },
    setCuNumber(commit, cun) {
      this.commit('setCun', cun);
      // this.commit('storeDiag', `Specified CU#: ${cun}`);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js